import React from 'react';
import styles from './anup.module.css';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

interface anupProps {}

const Anup: React.FC<anupProps> = () => {

    const navigate = useNavigate();

    const emailinputRef = useRef<HTMLInputElement>(null);
    const home = () =>{
      navigate('/');
    }
    return (
        <>
    <div className={styles.home}>
      <div className={styles.bg}></div>
      <div className={styles.frame_3}>
        <div className={styles.name}>
          <div className={styles.form}>
            <div className={styles.placeholder}><input type="text" ref={emailinputRef} className={styles.input_content} placeholder='Enter your email address' aria-label="Email" required/></div>
          </div>
        </div>
        <div className={styles.button_panel}>
          <div className={styles.button_frame}>
            <div className={styles.button_text} onClick={home}>
              Apply Now
            </div>
          </div>
        </div>
      </div>
      <div className={styles.frame_2}>
        <div className={styles.your_capital_partner_in_med_tech_innovation}>
          Your Capital Partner <br />in MedTech Innovation
        </div>
        <div className={styles.frame_1}>
          <div
            className={styles.pradhan_capital_leverages_frontline_expertise_to_fuel_healthcare_technology}
          >
            Pradhan Capital leverages frontline expertise to fuel healthcare
            technology.
          </div>
          <div
            className={styles.led_by_renowned_orthopaedic_surgeon_anup_pradhan_our_investment_team_propels_innovators_and_investors_empowering_startups_that_reimagine_healthcare_through_technology_specializing_in_identifying_and_nurturing_promising_healthcare_tech_startups_we_drive_transformative_change}
          >
            Led by renowned orthopaedic surgeon, Anup Pradhan, our investment
            team propels innovators and investors, empowering startups that
            reimagine healthcare through technology. Specializing in identifying
            and nurturing promising healthcare tech startups, we drive
            transformative change.
          </div>
        </div>
      </div>
      <div className={styles.partner}>
        <div className={styles.partnered_with}>Partnered With</div>
        <div className={styles.frame_5}>
          <div className={styles.group_39787}>
            <img
              className={styles.image_2_removebg_preview_1}
              src="/images/anup/image-2-removebg-preview-10.png"
            /><img
              className={styles.image_2_removebg_preview_3}
              src="/images/anup/image-2-removebg-preview-30.png"
            /><img
              className={styles.image_2_removebg_preview_2}
              src="/images/anup/image-2-removebg-preview-20.png"
            />
          </div>
        </div>
        <img
          className={styles.image_1_removebg_preview_1}
          src="/images/anup/image-1-removebg-preview-10.png"
        />
        <div className={styles.frame_39793}>
          <svg
            className={styles.layer_1}
            width="41"
            height="41"
            viewBox="0 0 41 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.70775"
              y="1.33333"
              width="38.3333"
              height="38.3333"
              rx="19.1667"
              stroke="#8B98B8"
              stroke-width="1.66667"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.7868 19.4399C19.3827 13.7787 16.9532 10.1487 10.7106 10.3406C10.5192 16.5991 14.14 19.0345 19.7868 19.4399ZM10.6545 8.508C17.8003 8.28835 21.1275 12.5403 21.611 19.309L21.7619 21.4197L19.6566 21.2683C12.9047 20.784 8.66355 17.4487 8.88264 10.2844L8.93551 8.561L10.6545 8.508Z"
              fill="#8B98B8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.9622 19.4406C27.6091 19.0352 31.2299 16.5998 31.0385 10.3413C24.7958 10.1494 22.3667 13.7794 21.9622 19.4406ZM32.8664 10.2851C33.0855 17.4491 28.8444 20.7847 22.0928 21.2694L19.9875 21.4207L20.1384 19.31C20.6215 12.541 23.9487 8.28905 31.0946 8.5087L32.8136 8.56138L32.8661 10.2848L32.8664 10.2851Z"
              fill="#8B98B8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M30.8389 30.5201C30.4344 24.8589 28.0053 21.2288 21.7626 21.4207C21.5712 27.6792 25.192 30.1146 30.8389 30.5201ZM21.7065 19.5881C28.8523 19.3685 32.1796 23.6204 32.663 30.3892L32.8139 32.4998L30.7086 32.3485C23.9571 31.8638 19.7159 28.5285 19.935 21.3642L19.9875 19.6408L21.7065 19.5881Z"
              fill="#8B98B8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.9109 30.52C16.5578 30.1146 20.1789 27.6792 19.9875 21.4207C13.7448 21.2288 11.3154 24.8588 10.9109 30.52ZM21.8152 21.3645C22.0342 28.5285 17.7931 31.8641 11.0415 32.3488L8.9362 32.5001L9.08715 30.3895C9.57056 23.6207 12.8978 19.3688 20.0436 19.5884L21.7626 19.6411L21.8152 21.3645Z"
              fill="#8B98B8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.3054 15.5082C32.805 18.6389 32.8216 22.3051 31.3554 25.4479L29.9618 24.0508C30.8459 21.753 30.8315 19.1878 29.9182 16.899L31.3054 15.5082ZM15.9705 10.0236C19.0739 8.56808 22.689 8.57063 25.791 10.0294L24.3984 11.4255C22.1406 10.5488 19.6229 10.5472 17.3638 11.4207L15.9705 10.0236ZM10.4004 25.4591C8.92694 22.3105 8.9435 18.6342 10.4504 15.4971L11.8363 16.8865C10.9163 19.183 10.902 21.7585 11.7924 24.0636L10.4001 25.4594L10.4004 25.4591ZM25.8961 30.9817C22.7358 32.5075 19.0267 32.5097 15.8651 30.9878L17.2523 29.597C19.5767 30.529 22.1864 30.5277 24.5099 29.5923L25.8961 30.9817Z"
              fill="#8B98B8"
            />
          </svg>

          <div className={styles.dallas_dermatology_partners}>
            Dallas <br />Dermatology <br />Partners
          </div>
        </div>
      </div>
      <div className={styles.logo}>
        <div className={styles.mask_group}>
          <div className={styles.ellipse_443}></div>
          <div className={styles.group_39786}>
            <div className={styles.ellipse_444}></div>
            <div className={styles.ellipse_445}></div>
            <div className={styles.ellipse_446}></div>
            <div className={styles.ellipse_447}></div>
          </div>
        </div>
        <div className={styles.pradhan_capital}>Pradhan Capital</div>
      </div>
      <div className={styles.button2}>
        <div className={styles.button_normal}>Apply Now</div>
      </div>
      <img className={styles.image} src="/images/anup/image0.png" />
      <div className={styles.frame_6}>
        <div className={styles.frame_4}>
          <div className={styles.med_tech_startups}>MedTech Startups:</div>
          <div className={styles.why_partner_with_pradhan_capital}>
            Why Partner with Pradhan Capital?
          </div>
          <div
            className={styles.partnering_with_pradhan_capital_can_help_propel_your_early_stage_med_tech_startup_to_new_heights}
          >
            Partnering with Pradhan Capital can help propel your early-stage
            MedTech startup to new heights:
          </div>
        </div>
        <div className={styles.steps}>
          <div className={styles.cards}>
            <div className={styles._1}>1</div>
            <div className={styles.content}>
              <div className={styles.icon}>
                <div className={styles.ellipse_4}></div>
                <div className={styles.icon_line_primary_care}>
                  <div className={styles.group_22}>
                    <svg
                      className={styles.group}
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 0.666504C6.64256 0.666504 0.666656 6.64241 0.666656 13.9998C0.666656 21.3573 6.64256 27.3332 14 27.3332C21.3574 27.3332 27.3333 21.3573 27.3333 13.9998C27.3333 6.64241 21.3574 0.666504 14 0.666504ZM14 26.1765C7.28513 26.1765 1.82328 20.7147 1.82328 13.9998C1.82328 7.28498 7.28513 1.82313 14 1.82313C20.7148 1.82313 26.1767 7.28498 26.1767 13.9998C26.1767 20.7147 20.7148 26.1765 14 26.1765Z"
                        fill="#1EBCB4"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.333328 13.9999C0.333328 6.45839 6.45847 0.333252 14 0.333252C21.5415 0.333252 27.6667 6.45839 27.6667 13.9999C27.6667 21.5414 21.5415 27.6666 14 27.6666C6.45847 27.6666 0.333328 21.5414 0.333328 13.9999ZM14 0.999919C6.82666 0.999919 0.999995 6.82658 0.999995 13.9999C0.999995 21.1733 6.82666 26.9999 14 26.9999C21.1733 26.9999 27 21.1733 27 13.9999C27 6.82658 21.1733 0.999919 14 0.999919ZM14 2.15655C7.46923 2.15655 2.15662 7.46915 2.15662 13.9999C2.15662 20.5307 7.46923 25.8433 14 25.8433C20.5308 25.8433 25.8434 20.5307 25.8434 13.9999C25.8434 7.46915 20.5308 2.15655 14 2.15655ZM1.48995 13.9999C1.48995 7.10096 7.10104 1.48988 14 1.48988C20.8989 1.48988 26.51 7.10096 26.51 13.9999C26.51 20.8989 20.8989 26.51 14 26.51C7.10104 26.51 1.48995 20.8989 1.48995 13.9999Z"
                        fill="#1EBCB4"
                      />
                    </svg>

                    <div className={styles.group3}>
                      <div className={styles.group3}>
                        <div className={styles.group_23}>
                          <div className={styles.rectangle_20}></div>
                          <div className={styles.rectangle_21}></div>
                        </div>
                        <svg
                          className={styles.vector3}
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.9399 5.1082H10.8917V1.06C10.8917 0.738717 10.6347 0.481689 10.3134 0.481689H5.6869C5.36562 0.481689 5.10859 0.738717 5.10859 1.06V5.1082H1.0604C0.739114 5.1082 0.482086 5.36523 0.482086 5.68651V10.313C0.482086 10.6343 0.739114 10.8913 1.0604 10.8913H5.10859V14.9395C5.10859 15.2608 5.36562 15.5178 5.6869 15.5178H10.3134C10.6347 15.5178 10.8917 15.2608 10.8917 14.9395V10.8913H14.9399C15.2612 10.8913 15.5182 10.6343 15.5182 10.313V5.68651C15.4861 5.36523 15.2291 5.1082 14.9399 5.1082ZM14.3937 9.73471H14.3616H10.3134C9.99212 9.73471 9.7351 9.99173 9.7351 10.313V14.3612H6.26522V10.313C6.26522 9.99173 6.00819 9.73471 5.6869 9.73471H1.63871V6.26482H5.6869C6.00819 6.26482 6.26522 6.0078 6.26522 5.68651V1.63832H9.76723V5.68651C9.76723 6.0078 10.0243 6.26482 10.3455 6.26482H14.3937V9.73471Z"
                            fill="#1EBCB4"
                          />
                        </svg>

                        <svg
                          className={styles.vector_stroke2}
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M4.77526 1.06008C4.77526 0.554704 5.18153 0.148438 5.68691 0.148438H10.3134C10.8188 0.148438 11.2251 0.554704 11.2251 1.06008V4.77495H14.9399C15.4294 4.77495 15.8038 5.19227 15.8499 5.65342L15.8516 5.66997V10.3131C15.8516 10.8185 15.4453 11.2247 14.9399 11.2247H11.2251V14.9396C11.2251 15.445 10.8188 15.8513 10.3134 15.8513H5.68691C5.18153 15.8513 4.77526 15.445 4.77526 14.9396V11.2247H1.0604C0.555024 11.2247 0.148758 10.8185 0.148758 10.3131V5.68659C0.148758 5.18121 0.555024 4.77495 1.0604 4.77495H4.77526V1.06008ZM5.68691 0.815104C5.54972 0.815104 5.44193 0.922894 5.44193 1.06008V5.44161H1.0604C0.923214 5.44161 0.815425 5.5494 0.815425 5.68659V10.3131C0.815425 10.4503 0.923215 10.5581 1.0604 10.5581H5.44193V14.9396C5.44193 15.0768 5.54972 15.1846 5.68691 15.1846H10.3134C10.4506 15.1846 10.5584 15.0768 10.5584 14.9396V10.5581H14.9399C15.0771 10.5581 15.1849 10.4503 15.1849 10.3131V5.70581C15.1612 5.53339 15.0265 5.44161 14.9399 5.44161H10.5584V1.06008C10.5584 0.922894 10.4506 0.815104 10.3134 0.815104H5.68691ZM5.93189 1.30506H10.1006V5.68659C10.1006 5.82378 10.2084 5.93157 10.3455 5.93157H14.7271V10.0681H10.3134C10.1762 10.0681 10.0684 10.1759 10.0684 10.3131V14.6946H5.93189V10.3131C5.93189 10.1759 5.8241 10.0681 5.68691 10.0681H1.30538V5.93157H5.68691C5.8241 5.93157 5.93189 5.82378 5.93189 5.68659V1.30506ZM6.59856 1.97173V5.68659C6.59856 6.19197 6.19229 6.59824 5.68691 6.59824H1.97205V9.40145H5.68691C6.19229 9.40145 6.59856 9.80772 6.59856 10.3131V14.028H9.40177V10.3131C9.40177 9.80772 9.80804 9.40145 10.3134 9.40145H14.0604V6.59824H10.3455C9.84016 6.59824 9.4339 6.19197 9.4339 5.68659V1.97173H6.59856Z"
                            fill="#1EBCB4"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.find_clinic}>We Have Deep Healthcare Network</div>
              <div
                className={styles.pradhan_capital_provides_more_than_just_capital_investment_we_offer_invaluable_professional_guidance_leveraging_our_extensive_network_and_expertise_to_accelerate_your_startup_s_development_read_more}
              >
                <span
                  ><span
                    className={styles.pradhan_capital_provides_more_than_just_capital_investment_we_offer_invaluable_professional_guidance_leveraging_our_extensive_network_and_expertise_to_accelerate_your_startup_s_development_read_more_span}
                    >Pradhan Capital provides more than just capital investment.
                    We offer invaluable professional guidance, leveraging our
                    extensive network and<br />expertise to accelerate your
                    startup&#039;s development...</span
                  ><span
                    className={styles.pradhan_capital_provides_more_than_just_capital_investment_we_offer_invaluable_professional_guidance_leveraging_our_extensive_network_and_expertise_to_accelerate_your_startup_s_development_read_more_span2}
                    >Read More</span
                  ></span
                >
              </div>
            </div>
          </div>
          <div className={styles.cards}>
            <div className={styles._12}>2</div>
            <div className={styles.content}>
              <div className={styles.icon2}>
                <div className={styles.ellipse_42}></div>
                <svg
                  className={styles.icon_line_search}
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="13.3211"
                    cy="13.3333"
                    rx="9.32882"
                    ry="9.33333"
                    fill="white"
                  />
                  <ellipse
                    cx="13.3211"
                    cy="13.3333"
                    rx="9.99516"
                    ry="10"
                    stroke="#FFB201"
                    stroke-width="1.8"
                  />
                  <path
                    d="M27.9806 28.0001L20.6508 20.6667"
                    stroke="#FFB201"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.find_clinic}>We Understand <br />Medicine</div>
              <div
                className={styles.our_comprehensive_knowledge_and_extensive_experience_in_healthcare_as_providers_and_users_of_innovative_healthcare_technologies_allow_us_to_grasp_the_complexities_and_nuances_of_the_medical_field_read_more}
              >
                <span
                  ><span
                    className={styles.our_comprehensive_knowledge_and_extensive_experience_in_healthcare_as_providers_and_users_of_innovative_healthcare_technologies_allow_us_to_grasp_the_complexities_and_nuances_of_the_medical_field_read_more_span}
                    >Our comprehensive knowledge and extensive experience in
                    healthcare as providers and users of innovative healthcare
                    technologies allow us to grasp the complexities and nuances
                    of the medical field...</span
                  ><span
                    className={styles.our_comprehensive_knowledge_and_extensive_experience_in_healthcare_as_providers_and_users_of_innovative_healthcare_technologies_allow_us_to_grasp_the_complexities_and_nuances_of_the_medical_field_read_more_span2}
                    >Read More</span
                  ></span
                >
              </div>
            </div>
          </div>
          <div className={styles.cards}>
            <div className={styles._3}>3</div>
            <div className={styles.content}>
              <div className={styles.icon2}>
                <div className={styles.ellipse_45}></div>
                <div className={styles.icon_line_appointment}>
                  <svg
                    className={styles.vector_29}
                    width="24"
                    height="19"
                    viewBox="0 0 24 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.99035 12.6667L1.32497 6.66675L0.65863 6.00008L5.98938 0.666748L8.65476 2.66675L11.3201 2.00008L15.9845 2.66675L18.6499 0.666748L23.3143 5.33342L21.3153 8.66675L18.6499 14.0001L17.3172 16.6667L13.9855 18.0001L10.6538 18.6667H7.98842L5.98938 16.6667L4.6567 15.3334L3.99035 12.6667Z"
                      fill="white"
                    />
                  </svg>

                  <svg
                    className={styles.group4}
                    width="32"
                    height="26"
                    viewBox="0 0 32 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M31.8289 7.69215L25.6257 1.48588C25.4262 1.28625 25.1028 1.28625 24.9032 1.48588L21.8016 4.58898C21.7059 4.6848 21.6521 4.8148 21.6521 4.95036C21.6521 5.08592 21.7059 5.21592 21.8016 5.31173L22.111 5.62129L21.4 6.33254C20.9384 6.79416 20.2222 6.92016 19.6179 6.64572C19.0513 6.38841 18.4214 6.25247 17.7962 6.25247C17.0539 6.25247 16.3284 6.43891 15.6839 6.79203C15.4151 6.72578 15.1392 6.69185 14.8606 6.69185C14.4577 6.69185 14.0619 6.76141 13.6844 6.89872C13.0815 7.11784 12.4352 6.98203 11.9975 6.54422L10.7208 5.26686L10.8729 5.11473C10.9686 5.01892 11.0224 4.88892 11.0224 4.75336C11.0224 4.6178 10.9686 4.4878 10.8729 4.39199L7.77125 1.28888C7.57166 1.08925 7.24832 1.08925 7.04879 1.28888L0.1438 8.19721C-0.0556645 8.39684 -0.0556645 8.7204 0.1438 8.91996L3.24534 12.0231C3.34117 12.1189 3.47105 12.1728 3.6066 12.1728C3.74216 12.1728 3.87197 12.1189 3.96786 12.0231L4.15284 11.838L5.05327 12.7389C5.28047 12.9662 5.43108 13.25 5.48874 13.5596C5.78772 15.1647 6.5561 16.624 7.71078 17.7799L7.88038 17.9496C7.55467 18.2928 7.37551 18.7399 7.37551 19.2149C7.37551 19.7062 7.56679 20.1681 7.91399 20.5156C8.27244 20.8742 8.74315 21.0535 9.21404 21.0535C9.24472 21.0535 9.27526 21.0526 9.30594 21.0511C9.28107 21.5523 9.45949 22.0617 9.84117 22.4437C10.1884 22.7911 10.6502 22.9824 11.1412 22.9824C11.1549 22.9824 11.1685 22.9818 11.1822 22.9814C11.1717 23.4657 11.3503 23.9534 11.7189 24.3222C12.0661 24.6697 12.5279 24.861 13.019 24.861C13.5101 24.861 13.9717 24.6696 14.319 24.3222C14.3483 24.293 14.3758 24.2627 14.4028 24.2321C14.5836 24.2952 14.7749 24.3287 14.9682 24.3287C15.4276 24.3287 15.8591 24.1497 16.1827 23.8249C16.3549 23.6526 16.4856 23.45 16.5707 23.2293L16.623 23.2816C16.9578 23.6166 17.3975 23.7841 17.8372 23.7841C18.2769 23.7841 18.7166 23.6166 19.0514 23.2816C19.2293 23.1036 19.363 22.8934 19.4477 22.6643C19.7474 22.8823 20.1021 22.9915 20.4571 22.9915C20.8968 22.9915 21.3368 22.8241 21.6719 22.4893C21.9962 22.1648 22.1748 21.7332 22.1748 21.274C22.1748 21.1352 22.1581 20.9991 22.1265 20.8676C22.4536 20.8011 22.7542 20.6404 22.9954 20.3988C23.3197 20.0743 23.4983 19.6429 23.4983 19.184C23.4983 18.8224 23.387 18.4782 23.1814 18.1896L23.5912 17.7796C24.7593 16.6104 25.531 15.1327 25.8229 13.5064C25.8718 13.2341 26.0066 12.9812 26.2129 12.7747L27.737 11.2499L28.005 11.5179C28.1047 11.6178 28.2355 11.6676 28.3662 11.6676C28.4969 11.6676 28.6277 11.6178 28.7275 11.5179L31.8291 8.41484C31.9249 8.31903 31.9786 8.18903 31.9786 8.05346C31.9786 7.9179 31.9247 7.78803 31.8289 7.69215ZM3.6066 10.939L1.22739 8.55865L7.40993 2.37312L9.7892 4.75348L3.6066 10.939ZM9.79164 19.793C9.47323 20.1115 8.95505 20.1116 8.63639 19.793C8.48209 19.6385 8.39713 19.4333 8.39713 19.215C8.39713 18.9968 8.48215 18.7915 8.63645 18.6372C8.79569 18.4778 9.00477 18.3982 9.21398 18.3982C9.42313 18.3982 9.6324 18.4778 9.79157 18.6372C10.11 18.9558 10.11 19.4743 9.79164 19.793ZM11.7187 21.7209C11.5645 21.8754 11.3594 21.9603 11.1411 21.9603C10.923 21.9603 10.7178 21.8753 10.5636 21.7209C10.245 21.4023 10.245 20.8838 10.5636 20.5651C10.7228 20.4058 10.9319 20.3261 11.1412 20.3261C11.3502 20.3261 11.5595 20.4058 11.7187 20.5651C12.0373 20.8838 12.0373 21.4023 11.7187 21.7209ZM13.5964 23.5995C13.4421 23.7539 13.237 23.8389 13.0189 23.8389C12.8007 23.8389 12.5955 23.7538 12.4413 23.5995C12.1227 23.2809 12.1227 22.7624 12.4413 22.4437C12.6005 22.2844 12.8096 22.2047 13.0189 22.2047C13.228 22.2047 13.4372 22.2844 13.5964 22.4437C13.9149 22.7624 13.9149 23.2809 13.5964 23.5995ZM22.2726 19.6763C22.1413 19.8078 21.9667 19.8802 21.7811 19.8802C21.5954 19.8802 21.4208 19.8078 21.2893 19.676L16.3336 14.719C16.1339 14.5194 15.8106 14.5195 15.6111 14.7191C15.4117 14.9187 15.4118 15.2423 15.6112 15.4419L20.9493 20.782C21.0807 20.9133 21.1529 21.0881 21.1529 21.274C21.1529 21.4602 21.0806 21.6351 20.9495 21.7663C20.6779 22.0378 20.2363 22.0378 19.9652 21.7665L19.0647 20.8655C19.0597 20.8603 19.0548 20.8551 19.0496 20.85C19.0481 20.8485 19.0464 20.8471 19.0449 20.8456L14.9052 16.704C14.7056 16.5044 14.3823 16.5044 14.1827 16.704C13.9832 16.9035 13.9832 17.2272 14.1827 17.4267L18.3357 21.5816C18.4626 21.7118 18.5325 21.8841 18.5325 22.0668C18.5325 22.2527 18.4601 22.4274 18.3288 22.5588C18.0578 22.8301 17.6166 22.8301 17.3454 22.5588L12.8423 18.0535C12.6427 17.8538 12.3193 17.8538 12.1198 18.0535C11.9203 18.253 11.9203 18.5767 12.1198 18.7762L15.4578 22.1159C15.4587 22.1168 15.4595 22.1179 15.4605 22.1188C15.5917 22.2498 15.6639 22.4243 15.6639 22.6099C15.6639 22.7958 15.5916 22.9705 15.4597 23.1024C15.3286 23.2339 15.1541 23.3064 14.9681 23.3064C14.9232 23.3064 14.8793 23.3018 14.8363 23.2936C14.9189 22.7366 14.7466 22.1486 14.3189 21.7207C13.9717 21.3733 13.5099 21.1819 13.0189 21.1819C13.0052 21.1819 12.9916 21.1826 12.9779 21.1829C12.9884 20.6986 12.8098 20.211 12.4412 19.8421C12.0939 19.4948 11.6322 19.3034 11.1411 19.3034C11.1104 19.3034 11.0798 19.3041 11.0493 19.3056C11.0739 18.8048 10.8955 18.2958 10.514 17.914C10.0496 17.4495 9.39677 17.2863 8.79956 17.4236L8.43324 17.0571C7.42498 16.0479 6.75419 14.7737 6.49313 13.3721C6.39749 12.8588 6.14942 12.3898 5.77579 12.0159L4.87529 11.115L9.99841 5.98941L11.2752 7.26678C11.7659 7.75778 12.4341 8.02053 13.1184 8.02053C13.4249 8.02053 13.7348 7.96778 14.0334 7.85922C14.1782 7.80653 14.3279 7.76872 14.4797 7.74472L11.3167 10.9093C10.9297 11.2964 10.7166 11.8111 10.7166 12.3587C10.7166 12.9062 10.9297 13.4209 11.3166 13.8081C11.7161 14.2077 12.2406 14.4074 12.7653 14.4074C13.2899 14.4074 13.8146 14.2075 14.2141 13.8081L15.8027 12.2187L16.2327 12.6492C16.2328 12.6493 16.2329 12.6494 16.233 12.6495L16.2508 12.6674L16.268 12.6846C16.2681 12.6846 16.2682 12.6847 16.2683 12.6848L16.2687 12.6851C16.2736 12.69 16.2784 12.6946 16.2832 12.6992L22.2728 18.6918C22.4042 18.8232 22.4765 18.9979 22.4765 19.1838C22.4765 19.37 22.4042 19.5447 22.2726 19.6763ZM25.4903 12.0521C25.1358 12.4068 24.903 12.8472 24.8172 13.3259C24.5623 14.7459 23.8885 16.0361 22.8686 17.057L22.476 17.4498L19.2444 14.2166C19.3147 14.2218 19.3852 14.2252 19.4562 14.2252C19.7834 14.2252 20.1183 14.1679 20.4516 14.0314C20.7127 13.9246 20.8378 13.6261 20.731 13.3649C20.6241 13.1037 20.3261 12.9786 20.0648 13.0854C18.7501 13.6236 17.1738 12.1404 16.9984 11.9695C16.9954 11.9666 16.9925 11.9638 16.9895 11.9611L16.9714 11.9429C16.9713 11.9429 16.9712 11.9429 16.9712 11.9428L16.9554 11.9271C16.9553 11.927 16.9552 11.9269 16.9551 11.9268L16.525 11.4963L17.0127 11.0083C17.2122 10.8087 17.2122 10.4851 17.0127 10.2855C16.8132 10.086 16.4898 10.086 16.2903 10.2855L15.4426 11.1336C15.4423 11.1339 15.4419 11.1343 15.4416 11.1346C15.4413 11.1349 15.441 11.1353 15.4407 11.1356L13.4916 13.0856C13.0911 13.4862 12.4395 13.4861 12.0391 13.0856C11.8451 12.8915 11.7383 12.6334 11.7383 12.3589C11.7383 12.0844 11.8451 11.8264 12.0392 11.6323L15.4033 8.26646C15.5904 8.07928 15.7984 7.91459 16.022 7.77665C16.5532 7.44815 17.1667 7.27453 17.7962 7.27453C18.2768 7.27453 18.7607 7.37891 19.1957 7.57647C20.1854 8.02571 21.3616 7.8164 22.1225 7.05534L22.8336 6.34404L27.0146 10.5271L25.4903 12.0521ZM28.366 10.434L22.8852 4.95048L25.2645 2.57012L30.7453 8.05359L28.366 10.434Z"
                      fill="#A27FFF"
                      stroke="#A27FFF"
                      stroke-width="0.5"
                    />
                  </svg>

                  <svg
                    className={styles.group6}
                    width="2"
                    height="3"
                    viewBox="0 0 2 3"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.880625 1.95547C1.16274 1.95547 1.39144 1.72666 1.39144 1.44441C1.39144 1.16216 1.16274 0.93335 0.880625 0.93335C0.598511 0.93335 0.369812 1.16216 0.369812 1.44441C0.369812 1.72666 0.598511 1.95547 0.880625 1.95547Z"
                      fill="#A27FFF"
                      stroke="#A27FFF"
                      stroke-width="0.5"
                    />
                  </svg>

                  <svg
                    className={styles.group8}
                    width="3"
                    height="2"
                    viewBox="0 0 3 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.34046 1.46035C1.62258 1.46035 1.85128 1.23154 1.85128 0.949292C1.85128 0.667042 1.62258 0.438232 1.34046 0.438232C1.05835 0.438232 0.829651 0.667042 0.829651 0.949292C0.829651 1.23154 1.05835 1.46035 1.34046 1.46035Z"
                      fill="#A27FFF"
                      stroke="#A27FFF"
                      stroke-width="0.5"
                    />
                  </svg>
                </div>
              </div>
              <div className={styles.we_support_early_stage_med_tech_startups}>
                We Support Early-Stage MedTech Startups
              </div>
              <div
                className={styles.our_investment_strategy_focuses_primarily_on_pre_seed_and_seed_stages_we_want_to_nuture_new_ideas_and_innovations_in_healthcare_with_investments_ranging_from_50_000_to_100_000_per_deal_we_read_more}
              >
                <span
                  ><span
                    className={styles.our_investment_strategy_focuses_primarily_on_pre_seed_and_seed_stages_we_want_to_nuture_new_ideas_and_innovations_in_healthcare_with_investments_ranging_from_50_000_to_100_000_per_deal_we_read_more_span}
                    >Our investment strategy focuses primarily on pre-seed and
                    seed stages.  We want to nuture new ideas and innovations in
                    healthcare. With investments ranging from $50,000 to
                    $100,000 per deal, we...</span
                  ><span
                    className={styles.our_investment_strategy_focuses_primarily_on_pre_seed_and_seed_stages_we_want_to_nuture_new_ideas_and_innovations_in_healthcare_with_investments_ranging_from_50_000_to_100_000_per_deal_we_read_more_span2}
                    >Read More</span
                  ></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.frame_10}>
        <div className={styles.frame_102}>
          <div className={styles.our_portfolio}>Our Portfolio</div>
          <div className={styles.news_list}>
            <div className={styles.news_list2}>
              <div className={styles.news_1}>
                <img className={styles.image2} src="/images/anup/image1.png" />
                <div className={styles.content2}>
                  <div className={styles.new_york_post_logo}>
                    <div className={styles.group_39787}>
                      <img
                        className={styles.image_2_removebg_preview_12}
                        src="/images/anup/image-2-removebg-preview-11.png"
                      /><img
                        className={styles.image_2_removebg_preview_22}
                        src="/images/anup/image-2-removebg-preview-21.png"
                      />
                    </div>
                  </div>
                  <div
                    className={styles.mcd_surgery_cente_the_disruptive_and_modern_healthcare_service_in_this_year}
                  >
                    MCD Surgery Cente - The disruptive and modern healthcare
                    service in this year
                  </div>
                  <div className={styles.action}>
                    <svg className={styles.arrow_right} width="24" height="24"></svg>
                    <div className={styles.meta_data}>
                      <div className={styles._8_january_2022}>8 January 2022</div>
                      <div className={styles.ellipse_3}></div>
                      <div className={styles._2_457_reads}>2,457 Reads</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.news_2}>
                <img className={styles.image3} src="/images/anup/image2.png" />
                <div className={styles.content3}>
                  <div className={styles.new_york_post_logo}>
                    <div className={styles.group_39787}>
                      <img
                        className={styles.image_2_removebg_preview_12}
                        src="/images/anup/image-2-removebg-preview-12.png"
                      /><img
                        className={styles.image_2_removebg_preview_22}
                        src="/images/anup/image-2-removebg-preview-22.png"
                      />
                    </div>
                  </div>
                  <div
                    className={styles.mcd_surgery_cente_the_disruptive_and_modern_healthcare_service_in_this_year}
                  >
                    MCD Surgery Cente - The disruptive and modern healthcare
                    service in this year
                  </div>
                  <div className={styles.action}>
                    <svg
                      className={styles.arrow_right2}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.3651 12.5602L14.3851 17.5602C14.2251 17.7202 14.0251 17.8002 13.8251 17.8002C13.6251 17.8002 13.4251 17.7202 13.2651 17.5602C12.9451 17.2402 12.9451 16.7401 13.2651 16.4201L16.8851 12.7802H5.20509C4.76509 12.7802 4.40509 12.4202 4.40509 11.9802C4.40509 11.5402 4.76509 11.1802 5.20509 11.1802H16.8851L13.2651 7.54016C12.9451 7.22016 12.9451 6.72016 13.2651 6.40016C13.5851 6.08016 14.0851 6.08016 14.4051 6.40016L19.3851 11.4002C19.6851 11.7402 19.6851 12.2602 19.3651 12.5602Z"
                        fill="black"
                      />
                    </svg>

                    <div className={styles.meta_data}>
                      <div className={styles._28_july_2023}>28 July 2023</div>
                      <div className={styles.ellipse_3}></div>
                      <div className={styles._2_457_views}>2,457 Views</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.news_3}>
                <svg
                  className={styles.bg2}
                  width="228"
                  height="558"
                  viewBox="0 0 228 558"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 0H1000V558H0V0Z" fill="#E1E3E8" />
                </svg>

                <img className={styles.image4} src="/images/anup/image3.png" />
                <div className={styles.content4}>
                  <div className={styles.new_york_post_logo}>
                    <div className={styles.group_39787}>
                      <img
                        className={styles.image_2_removebg_preview_12}
                        src="/images/anup/image-2-removebg-preview-13.png"
                      /><img
                        className={styles.image_2_removebg_preview_22}
                        src="/images/anup/image-2-removebg-preview-23.png"
                      />
                    </div>
                  </div>
                  <div
                    className={styles.mcd_surgery_cente_the_disruptive_and_modern_healthcare_service_in_this_year}
                  >
                    MCD Surgery Cente - The disruptive and modern healthcare
                    service in this year
                  </div>
                  <div className={styles.action}>
                    <svg className={styles.arrow_right3} width="24" height="24"></svg>
                    <div className={styles.meta_data}>
                      <div className={styles._28_july_2023}>28 July 2023</div>
                      <div className={styles.ellipse_3}></div>
                      <div className={styles._2_457_views}>2,457 Views</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.nav}>
          <div className={styles.nav2}>
            <div className={styles.ellipse_2}></div>
            <svg
              className={styles.icon_line_arrow_right}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.00006 5L16.0001 12L9.00006 19"
                stroke="white"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className={styles._1_4}>
            <span
              ><span className={styles._1_4_span}>1/</span
              ><span className={styles._1_4_span2}>4</span></span
            >
          </div>
          <div className={styles.nav2}>
            <div className={styles.ellipse_22}></div>
            <svg
              className={styles.icon_line_arrow_right2}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.9999 5L7.99992 12L14.9999 19"
                stroke="#1E5DBC"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className={styles.frame_11}>
        <div className={styles.content5}>
          <div className={styles.indicator}>
            <div className={styles.rectangle_64}></div>
            <div className={styles.rectangle_65}></div>
            <div className={styles.rectangle_66}></div>
          </div>
          <div className={styles.locations}>
            <div className={styles.cards2}>
              <div className={styles.img}>
                <img className={styles.image_5} src="/images/anup/image-50.png" /><img
                  className={styles.d_2_wev_i_wqo_wd_4_i_tt_gw_hpg_z_76_qfj_3_vfn_hwl_gn_6_n_ezz_2_acs_lq_b_2_x_5_u_5_rp_dh_afv_a_2_npnq_6_qjj_0_dxnvh_09_i_tv_mmoeeq_fi_o_eg_sj_xp_9_zas_pyw_w_th_4_il_6_b_4_z_8_md_wp_2_pnm_ndv_bg_w_1280}
                  src="/images/anup/d-2-wev-i-wqo-wd-4-i-tt-gw-hpg-z-76-qfj-3-vfn-hwl-gn-6-n-ezz-2-acs-lq-b-2-x-5-u-5-rp-dh-afv-a-2-npnq-6-qjj-0-dxnvh-09-i-tv-mmoeeq-fi-o-eg-sj-xp-9-zas-pyw-w-th-4-il-6-b-4-z-8-md-wp-2-pnm-ndv-bg-w-12800.png"
                />
              </div>
              <div className={styles.text}>
                <div className={styles.anup_pradhan}>Anup Pradhan</div>
                <div className={styles.nav3}>
                  <div className={styles.founder_managing_director}>
                    Founder &amp; Managing Director
                  </div>
                  <svg
                    className={styles.icon_line_arrow_right_2}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5 7.5L20 12M20 12L15.5 16.5M20 12H4"
                      stroke="#262F56"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className={styles.cards2}>
              <div className={styles.img}>
                <img className={styles.image_4} src="/images/anup/image-40.png" />
              </div>
              <div className={styles.text}>
                <div className={styles.sonya_jagwani}>Sonya Jagwani</div>
                <div className={styles.nav3}>
                  <div className={styles.partner_chief_medical_officer}>
                    Partner &amp; Chief Medical Officer
                  </div>
                  <svg
                    className={styles.icon_line_arrow_right_22}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5 7.5L20 12M20 12L15.5 16.5M20 12H4"
                      stroke="#262F56"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className={styles.cards2}>
              <div className={styles.img}>
                <img className={styles.image_6} src="/images/anup/image-60.png" />
              </div>
              <div className={styles.text}>
                <div className={styles.sonya_jagwani}>Sonya Jagwani</div>
                <div className={styles.nav3}>
                  <div className={styles.partner_chief_medical_officer}>
                    Partner &amp; Chief Medical Officer
                  </div>
                  <svg
                    className={styles.icon_line_arrow_right_23}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5 7.5L20 12M20 12L15.5 16.5M20 12H4"
                      stroke="#262F56"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className={styles.cards2}>
              <div className={styles.img2}>
                <img
                  className={styles.image_41_removebg_preview_1}
                  src="/images/anup/image-41-removebg-preview-10.png"
                />
              </div>
              <div className={styles.text}>
                <div className={styles.james_sinclair}>James Sinclair</div>
                <div className={styles.nav3}>
                  <div className={styles.a_leader_in_start_ups_organizations}>
                    A Leader in StartUps Organizations
                  </div>
                  <svg
                    className={styles.icon_line_arrow_right_24}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5 7.5L20 12M20 12L15.5 16.5M20 12H4"
                      stroke="#262F56"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.title}>
            <div className={styles.our_team}>Our Team</div>
            <div className={styles.nav_slider}>
              <div className={styles.nav4}>
                <div className={styles.ellipse_23}></div>
                <svg
                  className={styles.icon_line_arrow_right3}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.9999 5L7.99994 12L14.9999 19"
                    stroke="#1E5DBC"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.nav4}>
                <div className={styles.ellipse_24}></div>
                <svg
                  className={styles.icon_line_arrow_right4}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00006 5L16.0001 12L9.00006 19"
                    stroke="white"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.frame_13}>
        <div className={styles.frame_39789}>
          <div className={styles.img3}>
            <div className={styles.image5}>
              <img className={styles.image6} src="/images/anup/image5.png" /><img
                className={styles.business_people_with_digital_tablet_blueprint_1}
                src="/images/anup/business-people-with-digital-tablet-blueprint-10.png"
              />
              <div className={styles.next_reading}>
                <div className={styles.rectangle_15}></div>
                <div className={styles.text2}>
                  <div className={styles.join_us}>Join Us</div>
                  <svg
                    className={styles.right_24_px}
                    width="26"
                    height="24"
                    viewBox="0 0 26 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.3716 7.50049L21.0562 12.0005M21.0562 12.0005L16.3716 16.5005M21.0562 12.0005H4.3998"
                      stroke="#1E5DBC"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.content6}>
            <div className={styles.title2}>
              <div className={styles.logo2}>
                <div className={styles.mask_group}>
                  <div className={styles.ellipse_443}></div>
                  <div className={styles.group_39786}>
                    <div className={styles.ellipse_444}></div>
                    <div className={styles.ellipse_445}></div>
                    <div className={styles.ellipse_446}></div>
                    <div className={styles.ellipse_447}></div>
                  </div>
                </div>
                <div className={styles.pradhan_capital}>Pradhan Capital</div>
              </div>
              <div className={styles.invest_alongside_pradhan_capital}>
                Invest Alongside Pradhan Capital
              </div>
            </div>
            <div
              className={styles.pradhan_capital_extends_a_unique_opportunity_for_physicians_and_healthcare_providers_to_participate_in_our_investments_and_gain_access_to_private_equity_type_companies_that_may_otherwise_be_challenging_to_reach}
            >
              Pradhan Capital extends a unique opportunity for physicians and
              healthcare providers to participate in our investments and gain
              access to private equity-type companies that may otherwise be
              challenging to reach.
            </div>
            <div className={styles.frame_39790}>
              <div
                className={styles.we_believe_in_the_power_of_collaboration_and_the_immense_value_that_healthcare_professionals_can_bring_to_the_table_as_investors_by_investing_alongside_us_physicians_and_healthcare_providers_can_broaden_their_investment_portfolio_and_contribute_to_the_advancement_of_innovative_healthcare_technologies}
              >
                We believe in the power of collaboration and the immense value
                that healthcare professionals can bring to the table as
                investors. By investing alongside us, physicians and healthcare
                providers can broaden their investment portfolio and contribute
                to the advancement of innovative healthcare technologies.
              </div>
              <div
                className={styles.this_mutually_beneficial_arrangement_fosters_a_dynamic_ecosystem_where_medical_expertise_and_financial_acumen_converge_ultimately_driving_transformative_change_in_the_industry}
              >
                This mutually beneficial arrangement fosters a dynamic ecosystem
                where medical expertise and financial acumen converge,
                ultimately driving transformative change in the industry.
              </div>
              <div
                className={styles.join_us_in_unlocking_new_investment_possibilities_and_shaping_the_future_of_healthcare_together}
              >
                Join us in unlocking new investment possibilities and shaping
                the future of healthcare together.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.frame_14}>
        <div
          className={styles.small_copyright_2023_pradhan_capital_llc_all_rights_reserved}
        >
          Copyright 2023, Pradhan Capital LLC / All Rights Reserved.
        </div>
      </div>
      <div className={styles.our_story}>
        <div className={styles.title3}>
          <div className={styles.our_services}>Our Services</div>
          <div className={styles.advisory_services}>Advisory Services</div>
        </div>
        <div className={styles.content5}>
          <div className={styles.img4}>
            <div className={styles.image5}>
              <img className={styles.image7} src="/images/anup/image7.png" />
              <div className={styles.bg3}></div>
            </div>
          </div>
          <div className={styles.statistics}>
            <div className={styles.statistics2}>
              <div className={styles.icon}>
                <div className={styles.icon3}></div>
                <div className={styles.icon_line_team}>
                  <svg
                    className={styles.rectangle_34}
                    width="6"
                    height="4"
                    viewBox="0 0 6 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.499512 0.5H5.49951V2.5L2.99951 3.5L0.499512 2.5V0.5Z"
                      fill="white"
                    />
                  </svg>

                  <svg
                    className={styles.rectangle_33}
                    width="6"
                    height="3"
                    viewBox="0 0 6 3"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.499512 0.5L2.99951 0L4.99951 0.5L5.99951 3H-0.000488281L0.499512 0.5Z"
                      fill="white"
                    />
                  </svg>

                  <svg
                    className={styles.rectangle_32}
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M-0.000488281 0H5.99951V3L2.99951 6L-0.000488281 3V0Z"
                      fill="white"
                    />
                  </svg>

                  <svg
                    className={styles.group10}
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.4764 5.66555C13.6706 5.66555 13.828 5.50814 13.828 5.31398V5.20898C13.828 5.01483 13.6706 4.85742 13.4764 4.85742C13.2823 4.85742 13.1249 5.01483 13.1249 5.20898V5.31398C13.1249 5.50819 13.2823 5.66555 13.4764 5.66555Z"
                      fill="#A27FFF"
                      stroke="#A27FFF"
                      stroke-width="0.3"
                    />
                    <path
                      d="M22.5476 9.14128C22.8592 8.68158 23.0415 8.12724 23.0415 7.53113C23.0415 5.93072 21.7282 4.63144 20.1235 4.65586C18.6086 4.67892 17.3572 5.89796 17.2955 7.41169C17.2696 8.05013 17.453 8.64535 17.7825 9.1343C17.3927 9.35972 16.9902 9.70486 16.6378 10.32C15.9113 9.98855 15.0553 9.80822 14.3263 9.65475C14.1525 9.61819 13.9848 9.58285 13.828 9.54745V9.25092C14.6048 8.78471 15.1766 8.08599 15.1766 7.4288C15.1766 7.3516 15.1699 7.28185 15.1577 7.21852C15.1895 7.14614 15.2188 7.07377 15.2456 7.00153C16.0096 6.92227 16.5585 6.49205 16.5585 5.94005L16.5612 5.16132C16.5612 4.76888 16.248 4.46152 15.8482 4.46152H15.4574L15.4583 3.62536C15.4597 2.67469 15.0814 1.87257 14.3643 1.30566C13.7451 0.816191 12.9135 0.541176 12.0227 0.531285C12.02 0.531238 12.0175 0.531238 12.0148 0.531285C11.124 0.541176 10.2924 0.816191 9.67325 1.30566C8.95611 1.87257 8.57778 2.67469 8.57918 3.62485V4.46152H8.18796C7.78817 4.46152 7.475 4.76892 7.475 5.16253L7.47767 5.94C7.4794 6.4921 8.02812 6.92161 8.7905 7.0013C8.81736 7.07382 8.84679 7.14638 8.87872 7.21903C8.86643 7.28231 8.85954 7.35169 8.85954 7.42885C8.85954 8.08589 9.43132 8.78442 10.2082 9.25064V9.5475C10.0514 9.58289 9.88371 9.61824 9.7099 9.6548C8.97101 9.81038 8.10172 9.99352 7.36892 10.3336C7.01412 9.71011 6.60861 9.36216 6.21612 9.13491C6.54598 8.64572 6.72959 8.05008 6.70348 7.41127C6.64161 5.89711 5.38929 4.67813 3.87406 4.65586C2.26925 4.63224 0.95623 5.93119 0.95623 7.53108C0.95623 8.12742 1.13876 8.68191 1.45071 9.1417C0.556809 9.69286 -0.000488281 10.6696 -0.000488281 11.7378V13.3181C-0.000488281 13.9065 0.476465 14.3834 1.06479 14.3834H4.22689C4.4194 14.3834 4.58726 14.2351 4.59303 14.0427C4.59903 13.8436 4.43937 13.6803 4.24161 13.6803H1.06461C0.864684 13.6803 0.702637 13.5182 0.702637 13.3183V11.7378C0.702637 10.8757 1.17523 10.091 1.92373 9.68011C2.06426 9.80508 2.21712 9.91627 2.3802 10.0121L3.56379 12.5129C3.62196 12.6358 3.74571 12.7141 3.88156 12.7141H3.88301C4.01909 12.7141 4.14279 12.6351 4.19993 12.5116L5.3877 9.94678C5.51295 9.86578 5.63159 9.77555 5.7425 9.67664C6.07611 9.84525 6.43306 10.1083 6.75851 10.6822C6.25995 11.0355 5.89732 11.5119 5.80465 12.1766L5.29887 15.3569C5.29596 15.375 5.29451 15.3934 5.29451 15.4118V17.0079C5.29451 17.5193 5.70982 17.9351 6.22029 17.9351H9.00514C9.35201 17.9351 9.67076 17.8113 9.9192 17.6051L11.5692 19.2405C11.685 19.3563 11.8386 19.464 12.0082 19.4687C12.1797 19.4734 12.3539 19.3613 12.4683 19.2405L14.0873 17.6351C14.3301 17.823 14.6344 17.9351 14.9648 17.9351H17.7483C18.2592 17.9351 18.6754 17.5193 18.6754 17.0079V15.4118C18.6754 15.4088 18.6737 15.3765 18.6719 15.3635L18.2322 12.1804C18.1387 11.5018 17.7643 11.0191 17.2511 10.6634C17.573 10.1024 17.9259 9.84277 18.256 9.67613C18.3671 9.77527 18.4859 9.86564 18.6114 9.94678L19.7991 12.5116C19.8563 12.6351 19.98 12.7141 20.1161 12.7141H20.1175C20.2534 12.7141 20.3772 12.6358 20.4353 12.5129L21.6191 10.0116C21.7819 9.91584 21.9345 9.80466 22.0748 9.67983C22.8236 10.0906 23.2964 10.8754 23.2964 11.7378V13.3181C23.2964 13.5178 23.1334 13.6803 22.9331 13.6803H19.7708C19.5783 13.6803 19.4104 13.8286 19.4047 14.021C19.3987 14.2201 19.5583 14.3834 19.7561 14.3834H22.9331C23.5211 14.3834 23.9995 13.9055 23.9995 13.3181V11.7378C23.9995 10.6693 23.4419 9.69235 22.5476 9.14128ZM15.457 5.88033V5.1646H15.8482C15.8525 5.1646 15.8558 5.16525 15.858 5.166L15.8554 5.93878C15.8554 6.03919 15.6968 6.17414 15.4332 6.25107C15.4489 6.12666 15.457 6.003 15.457 5.88033ZM8.18079 5.93761L8.17817 5.166C8.18037 5.16525 8.18365 5.1646 8.18796 5.1646H8.57918V5.88033C8.57918 6.00282 8.5872 6.12633 8.60295 6.25055C8.33975 6.1733 8.18112 6.03821 8.18079 5.93761ZM3.87809 11.5334L3.32314 10.3608C3.48814 10.3904 3.65768 10.4067 3.83103 10.4067C4.03606 10.4067 4.23598 10.3847 4.42901 10.3437L3.87809 11.5334ZM5.99389 7.72992C5.90121 8.76699 5.06632 9.60225 4.02926 9.69469C2.67612 9.81535 1.54728 8.68589 1.66826 7.33224C1.76093 6.29517 2.59578 5.45991 3.63289 5.36742C4.98598 5.24682 6.11487 6.37627 5.99389 7.72992ZM9.28236 3.62424C9.27996 2.00475 10.6984 1.25049 12.0188 1.23436C13.3392 1.25049 14.7576 2.00475 14.7552 3.62438L14.7548 3.99141C14.0868 3.54455 13.1054 3.27853 12.025 3.27853C12.0208 3.27853 12.0167 3.27853 12.0125 3.27853C10.9319 3.27853 9.95037 3.54436 9.28231 3.99089V3.62424H9.28236ZM9.40503 6.6256C9.39814 6.60403 9.39186 6.58233 9.38525 6.56067C9.31737 6.32878 9.28236 6.10116 9.28236 5.88033V4.92563C9.72289 4.35652 10.8008 3.98044 12.0184 3.98166C12.0206 3.98161 12.0228 3.98166 12.0251 3.98166C13.2382 3.98166 14.3141 4.35746 14.7539 4.92563V5.88033C14.7539 6.12169 14.7123 6.37111 14.6313 6.62546C14.5219 6.57647 14.4087 6.5363 14.2966 6.49421C13.3276 6.12455 12.6681 5.97272 12.0202 5.97C12.0192 5.97 12.0183 5.97 12.0173 5.97C11.3685 5.97267 10.7086 6.12455 9.74047 6.49388C9.62801 6.53606 9.51467 6.57647 9.40503 6.6256ZM9.56271 7.42875C9.56271 7.428 9.56271 7.42725 9.56271 7.42655C9.5629 7.36411 9.59923 7.30758 9.65511 7.27983C9.77975 7.21786 9.99021 7.15116 9.99021 7.15116C10.8735 6.81422 11.4614 6.67571 12.0188 6.67317C12.5753 6.67571 13.1628 6.81427 14.047 7.15149C14.1527 7.19119 14.2614 7.2278 14.3598 7.28372C14.4168 7.31606 14.4736 7.35746 14.4736 7.42875C14.4736 8.03269 13.261 9.0811 12.0188 9.09085C10.7759 9.0811 9.56271 8.03269 9.56271 7.42875ZM13.1248 9.58542V9.82519C13.1248 10.1373 13.0204 10.382 12.8146 10.5523C12.6255 10.7089 12.3598 10.7951 12.0667 10.7951C11.6023 10.7951 10.9114 10.5368 10.9114 9.82519V9.58514C11.271 9.71499 11.648 9.79144 12.0164 9.79392H12.0188C12.0188 9.79392 12.0204 9.79392 12.0212 9.79392C12.389 9.79144 12.7656 9.71508 13.1248 9.58542ZM9.85479 10.3428C9.99537 10.3132 10.1321 10.2844 10.2634 10.2555C10.4785 11.0656 11.2932 11.4982 12.0668 11.4982C12.5232 11.4982 12.948 11.3547 13.263 11.094C13.5258 10.8765 13.7 10.5915 13.779 10.2568C13.9085 10.2853 14.0431 10.3136 14.1815 10.3427C14.2815 10.3638 14.3833 10.3853 14.4861 10.4073L12.6877 12.804C12.4436 12.9204 12.2159 13.0719 12.0183 13.2493C11.8205 13.0719 11.5927 12.9205 11.3486 12.8041L9.5502 10.4074C9.65295 10.3853 9.75476 10.3638 9.85479 10.3428ZM6.49957 12.2835C6.49995 12.2811 6.50032 12.2787 6.50065 12.2762C6.63298 11.3156 7.68336 10.8708 8.80184 10.5816L10.28 12.5516C9.78584 12.5529 9.29717 12.7263 8.89972 13.1378C8.39253 13.6637 8.16518 14.3715 8.21768 15.0601H6.05801L6.49957 12.2835ZM9.41529 17.1057C9.29811 17.1854 9.15701 17.2318 9.00514 17.2318H6.22029C6.09748 17.2318 5.99764 17.1315 5.99764 17.0077V15.7632H9.00514C9.05717 15.7632 9.10779 15.7688 9.15654 15.7792C9.46732 15.8448 9.70639 16.1082 9.73498 16.4321C9.73686 16.4537 9.73779 16.4752 9.73779 16.4973C9.73779 16.7504 9.60982 16.9735 9.41529 17.1057ZM13.5277 16.4812C13.5254 16.6933 13.5692 16.8958 13.65 17.0781L12.0187 18.6962L10.3383 17.0307C10.4044 16.8657 10.4409 16.6857 10.4409 16.4973C10.4409 15.7046 9.79685 15.0601 9.00514 15.0601H8.92123C8.86686 14.5492 9.02857 14.0176 9.40545 13.6262C10.005 13.0056 10.9594 13.2409 11.5542 13.7781C11.5945 13.8137 11.6264 13.8446 11.6531 13.8695C11.7511 13.9623 11.8519 14.0579 12.0187 14.0579C12.1847 14.0579 12.2845 13.9628 12.3815 13.8709C12.4083 13.8456 12.4411 13.8146 12.4828 13.7771C13.0772 13.2409 14.0315 13.0056 14.6306 13.6257C15.0079 14.0171 15.1697 14.5487 15.1153 15.0601H14.9944C14.202 15.0601 13.5364 15.6889 13.5277 16.4812ZM17.9723 17.0077C17.9723 17.131 17.8715 17.2318 17.7483 17.2318H14.9648C14.8298 17.2318 14.7037 17.1953 14.595 17.1315C14.3784 17.0049 14.2326 16.7701 14.2308 16.502V16.4973C14.2308 16.1185 14.5181 15.8063 14.8865 15.7674C14.9123 15.7646 14.9386 15.7632 14.9648 15.7632H17.9723V17.0077ZM17.5356 12.2764L17.9202 15.0601H15.8189C15.8709 14.3715 15.6436 13.6637 15.1364 13.1378C14.739 12.7262 14.2504 12.5529 13.7562 12.5516L15.2344 10.5817C16.3529 10.8708 17.4033 11.3156 17.5356 12.2764ZM20.1209 11.5334L19.57 10.3437C19.763 10.3847 19.963 10.4067 20.168 10.4067C20.3414 10.4067 20.5109 10.3904 20.6759 10.3608L20.1209 11.5334ZM20.1679 9.70355C18.9156 9.70355 17.9074 8.63766 18.0024 7.36514C18.0817 6.30342 18.9379 5.44561 19.9996 5.36503C21.272 5.26847 22.3384 6.2775 22.3384 7.53113C22.3384 8.72902 21.3647 9.70355 20.1679 9.70355Z"
                      fill="#A27FFF"
                      stroke="#A27FFF"
                      stroke-width="0.3"
                    />
                    <path
                      d="M10.5599 5.66555C10.754 5.66555 10.9114 5.50814 10.9114 5.31398V5.20898C10.9114 5.01483 10.754 4.85742 10.5599 4.85742C10.3657 4.85742 10.2083 5.01483 10.2083 5.20898V5.31398C10.2083 5.50819 10.3657 5.66555 10.5599 5.66555Z"
                      fill="#A27FFF"
                      stroke="#A27FFF"
                      stroke-width="0.3"
                    />
                  </svg>
                </div>
              </div>
              <div className={styles.stat}>
                <div className={styles._90_k}>90K+</div>
                <div className={styles.professional_medical_team}>
                  Professional Medical team
                </div>
              </div>
            </div>
            <div className={styles.statistics2}>
              <div className={styles.icon}>
                <div className={styles.icon4}></div>
                <div className={styles.icon_line_medical_tech}>
                  <svg
                    className={styles.group11}
                    width="22"
                    height="18"
                    viewBox="0 0 22 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.2452 1H2.75385C1.7865 1 0.999512 1.78699 0.999512 2.75434V13.7383C0.999512 14.7056 1.7865 15.4926 2.75385 15.4926H7.90002L6.47936 17.1867C6.38182 17.303 6.36053 17.4653 6.42467 17.6029C6.48885 17.7404 6.62689 17.8283 6.77869 17.8283H15.2203C15.3721 17.8283 15.5102 17.7404 15.5744 17.6029C15.6385 17.4653 15.6172 17.303 15.5197 17.1867L14.099 15.4926H19.2452C20.2125 15.4926 20.9995 14.7056 20.9995 13.7383V2.75434C20.9995 1.78699 20.2125 1 19.2452 1ZM14.3829 17.0471H7.61607L8.91967 15.4927H13.0794L14.3829 17.0471ZM20.2183 13.7383C20.2183 14.2748 19.7817 14.7114 19.2452 14.7114H2.75385C2.21729 14.7114 1.78076 14.2748 1.78076 13.7383V2.75434C1.78076 2.21777 2.21729 1.78125 2.75385 1.78125H19.2452C19.7817 1.78125 20.2183 2.21777 20.2183 2.75434V13.7383Z"
                      fill="#1EBCB4"
                      stroke="#1EBCB4"
                      stroke-width="0.2"
                    />
                    <rect
                      x="2.99951"
                      y="3"
                      width="16"
                      height="8"
                      fill="white"
                    />
                    <path
                      d="M18.8853 2.72412H3.11388C2.89813 2.72412 2.72325 2.899 2.72325 3.11475V11.4193C2.72325 11.635 2.89813 11.8099 3.11388 11.8099H18.8853C19.101 11.8099 19.2759 11.635 19.2759 11.4193V3.11475C19.2759 2.899 19.101 2.72412 18.8853 2.72412ZM18.4947 11.0287H3.5045V3.50537H18.4947V11.0287Z"
                      fill="#1EBCB4"
                      stroke="#1EBCB4"
                      stroke-width="0.2"
                    />
                    <path
                      d="M7.03183 9.67561C7.09656 9.71768 7.17062 9.73869 7.24469 9.73869C7.31871 9.73869 7.39273 9.71768 7.45746 9.67564C7.7523 9.48416 9.2409 8.49865 9.59211 7.9019C9.73715 7.65545 9.92695 7.26475 9.90086 6.719C9.85664 5.79588 9.17144 5.07275 8.34097 5.07275C7.87941 5.07275 7.49226 5.28182 7.24508 5.46115C7.00019 5.28135 6.61472 5.07275 6.14422 5.07275C5.31375 5.07275 4.62855 5.79588 4.58429 6.71904C4.55816 7.26584 4.74812 7.65619 4.89324 7.90221C5.2425 8.49428 6.73597 9.48334 7.03183 9.67561ZM5.36472 6.75639C5.38855 6.25881 5.73828 5.854 6.14426 5.854C6.59773 5.854 6.94879 6.23314 6.95066 6.23514C7.02347 6.31705 7.12668 6.36533 7.23625 6.36693C7.34656 6.36865 7.45039 6.32471 7.52554 6.24498C7.52929 6.24107 7.90672 5.854 8.34097 5.854C8.74699 5.854 9.09668 6.25881 9.12051 6.75635C9.13312 7.01994 9.07281 7.244 8.91883 7.50561C8.74812 7.79561 7.90039 8.43689 7.24469 8.87943C6.58656 8.43545 5.73594 7.79303 5.56625 7.50529C5.41238 7.24451 5.35211 7.02053 5.36472 6.75639Z"
                      fill="#1EBCB4"
                      stroke="#1EBCB4"
                      stroke-width="0.2"
                    />
                    <path
                      d="M11.0069 7.39938H12.1281L12.5343 8.00785C12.6152 8.12907 12.7568 8.19512 12.9018 8.17926C13.0467 8.16332 13.1707 8.06805 13.2234 7.93211L13.4846 7.25793L13.9593 8.87727C14.0063 9.03747 14.1498 9.15012 14.3166 9.15762C14.3225 9.1579 14.3284 9.15801 14.3343 9.15801C14.4941 9.15801 14.6387 9.06028 14.6976 8.91043L15.3108 7.35219C15.3835 7.42922 15.4858 7.47473 15.5949 7.47473H17.0267C17.2424 7.47473 17.4173 7.29985 17.4173 7.0841C17.4173 6.86836 17.2424 6.69348 17.0267 6.69348H15.8368L15.6105 6.23859C15.5417 6.10043 15.3982 6.01582 15.2438 6.02234C15.0896 6.02906 14.9538 6.12594 14.8972 6.26957L14.3882 7.56317L13.9108 5.93457C13.8638 5.77402 13.7197 5.66125 13.5525 5.65418C13.3859 5.64691 13.2322 5.74726 13.1718 5.90332L12.7666 6.94883L12.6618 6.79188C12.5893 6.68332 12.4674 6.61813 12.3369 6.61813H11.0068C10.7911 6.61813 10.6162 6.79301 10.6162 7.00875C10.6163 7.22449 10.7911 7.39938 11.0069 7.39938Z"
                      fill="#1EBCB4"
                      stroke="#1EBCB4"
                      stroke-width="0.2"
                    />
                    <path
                      d="M11.5932 12.6455H10.4063C10.1905 12.6455 10.0156 12.8204 10.0156 13.0361C10.0156 13.2519 10.1905 13.4268 10.4063 13.4268H11.5932C11.809 13.4268 11.9839 13.2519 11.9839 13.0361C11.9839 12.8204 11.809 12.6455 11.5932 12.6455Z"
                      fill="#1EBCB4"
                      stroke="#1EBCB4"
                      stroke-width="0.2"
                    />
                  </svg>
                </div>
              </div>
              <div className={styles.stat}>
                <div className={styles._90_k}>500k+</div>
                <div className={styles.professional_medical_team}>
                  Hi-tech Medical Tools
                </div>
              </div>
            </div>
            <div className={styles.statistics2}>
              <div className={styles.icon}>
                <div className={styles.icon5}></div>
                <div className={styles.icon_line_location}>
                  <svg
                    className={styles.icon6}
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.4995 17.5C13.8328 15.5 11.3995 11.3 14.9995 10.5C16.9995 10.6667 19.8995 12.3 15.4995 17.5Z"
                      fill="white"
                    />
                    <path
                      d="M5.49948 8.5C3.83281 6.5 1.39948 2.3 4.99948 1.5C6.99947 1.66667 9.89945 3.3 5.49948 8.5Z"
                      fill="white"
                    />
                    <path
                      d="M20.9661 10.241C20.9777 10.2097 20.9844 10.177 20.9858 10.1436C20.9858 10.1084 20.9801 10.0733 20.9692 10.0399L20.9435 9.9671C20.671 7.33407 19.364 4.91709 17.3095 3.24799C17.1627 3.1284 17.0092 3.02037 16.8558 2.90957C16.8481 2.90322 16.844 2.89426 16.8357 2.88823C16.8274 2.8822 16.8207 2.88285 16.8137 2.87845C15.1151 1.66084 13.0788 1.00438 10.9888 1.00047C10.9028 1.00047 10.8162 1.00047 10.7519 1.00715C9.63709 1.02882 8.53435 1.24096 7.49108 1.63445C6.58663 0.928937 5.35891 0.801033 4.32835 1.30499C3.29779 1.80895 2.64491 2.85662 2.64654 4.00368C2.66658 4.38528 2.75521 4.76003 2.90853 5.10985C2.568 5.57535 2.2682 6.06921 2.01256 6.5862C2.00751 6.59418 2.00457 6.60282 2.00017 6.61113C-0.36564 11.5029 1.60294 17.3889 6.43575 19.8731C11.2684 22.3573 17.2005 20.5326 19.8016 15.7617C20.514 14.4493 20.9189 12.9921 20.9855 11.5005C20.9959 11.3395 20.9995 11.1754 20.9995 11.0112C20.9995 10.7526 20.9862 10.4963 20.9661 10.241ZM19.9965 8.52855C19.9541 8.49091 19.915 8.44741 19.8707 8.4127C19.4347 8.08162 18.9405 7.83477 18.4137 7.68503C17.9341 7.56462 17.4327 7.55941 16.9506 7.66972C16.5405 7.76259 16.1152 7.76471 15.7041 7.67591C14.9064 7.50173 14.276 7.36438 13.9417 6.83044C13.4628 6.06285 13.6873 4.98406 14.1926 4.60442C14.3591 4.48955 14.5646 4.44572 14.7635 4.48255C15.1174 4.51155 15.4731 4.45159 15.798 4.30837C16.1437 4.14641 16.4509 3.9126 16.699 3.62225C16.7621 3.67097 16.8287 3.7148 16.8905 3.76514C18.3963 4.99107 19.4819 6.65626 19.9965 8.52855ZM5.64975 1.66785C6.93905 1.66997 7.98363 2.71454 7.98558 4.00368C7.98558 5.00182 6.48642 7.28698 5.64975 8.44545C4.85642 7.37334 4.16704 6.22791 3.59123 5.02479C3.43433 4.70528 3.34015 4.35872 3.31392 4.00368C3.31538 2.71421 4.36028 1.66931 5.64975 1.66785ZM1.64546 11.0112C1.64677 10.3894 1.7095 9.76913 1.83268 9.15959C1.86836 9.62347 1.92881 10.0362 1.9829 10.3942C2.18967 11.7623 2.38503 13.0521 3.39343 14.2316C3.8151 14.7285 4.52126 15.5594 5.61309 15.6822C6.70492 15.8051 8.0721 15.1769 8.46706 14.9814L8.61858 14.905C8.82844 14.7729 9.06828 14.6961 9.31578 14.6818C9.73795 14.7201 10.129 14.9198 10.4076 15.2393C10.9771 15.8697 11.1216 16.9223 10.7169 17.4918C10.5872 17.6609 10.4081 17.7854 10.2043 17.8479C9.85542 17.9646 9.55888 18.201 9.36743 18.5153C9.08539 19.026 9.03293 19.6322 9.22324 20.1838C4.82856 19.3323 1.65231 15.4877 1.64546 11.0112ZM10.9888 20.3545C10.6663 20.3545 10.3442 20.3379 10.0234 20.3048C9.99604 20.2698 9.97062 20.2333 9.94732 20.1953C9.72182 19.7782 9.71937 19.2759 9.94096 18.8567C10.0614 18.6654 10.2479 18.5251 10.465 18.4625C10.7832 18.3529 11.0608 18.149 11.2607 17.8782C11.8411 17.0621 11.6769 15.6482 10.9037 14.7929C10.5016 14.3331 9.93265 14.0529 9.32311 14.0144H9.30829C8.95684 14.025 8.61435 14.127 8.31422 14.3105L8.17182 14.3825C7.44268 14.7419 6.40528 15.0973 5.68722 15.0165C4.85854 14.9237 4.28305 14.2456 3.9013 13.7966C3.01623 12.7621 2.84303 11.6175 2.64295 10.2928C2.4282 9.15959 2.41973 7.99705 2.61753 6.86075C2.79627 6.49887 2.99815 6.14888 3.22218 5.81291C3.23326 5.83507 3.24548 5.85772 3.25559 5.87971C3.27693 5.92208 3.29893 5.96411 3.32223 6.00648C3.35563 6.06953 3.38903 6.13259 3.42243 6.19613C3.4454 6.23882 3.4687 6.28151 3.49249 6.32453C3.52785 6.38791 3.56353 6.45129 3.59954 6.51467C3.62366 6.55671 3.64761 6.59891 3.67205 6.64095C3.7092 6.70433 3.74635 6.76738 3.78382 6.83044C3.80842 6.87183 3.83286 6.91288 3.85779 6.95394C3.89722 7.02058 3.93698 7.08299 3.97674 7.14735C3.99938 7.18385 4.02171 7.22083 4.04338 7.25684C4.09274 7.33603 4.14179 7.41277 4.19083 7.49049C4.20387 7.51053 4.2169 7.53155 4.22961 7.55126C4.29071 7.64593 4.35132 7.73831 4.41079 7.82842C4.43344 7.86182 4.45544 7.89522 4.4776 7.92862C4.51426 7.98369 4.55092 8.03876 4.5866 8.09139L4.66579 8.20724C4.69446 8.2496 4.72347 8.29197 4.75149 8.33237L4.83149 8.44741C4.85626 8.48325 4.88102 8.51828 4.90465 8.55185C4.92827 8.58557 4.955 8.6237 4.97976 8.65808C5.00436 8.69246 5.02115 8.71641 5.04086 8.74411L5.1075 8.83617L5.16192 8.91161L5.21504 8.98476L5.25838 9.04342L5.29911 9.09882L5.32339 9.13222C5.35321 9.17263 5.37586 9.20294 5.38221 9.21124C5.4451 9.29532 5.544 9.34485 5.6491 9.34485C5.75419 9.34485 5.85309 9.29532 5.91599 9.21124C6.19607 8.83992 8.65296 5.54602 8.65296 4.00368C8.65296 3.90625 8.64694 3.80946 8.63765 3.71333C8.63472 3.68368 8.62999 3.65402 8.62624 3.62437C8.61761 3.55757 8.60734 3.49076 8.593 3.42412C8.58665 3.39072 8.57964 3.35944 8.57231 3.32734C8.55683 3.26054 8.53891 3.1939 8.51854 3.12709C8.51023 3.10037 8.50323 3.07332 8.49443 3.04709C8.46445 2.95764 8.43072 2.86917 8.39243 2.78314C8.3851 2.76668 8.3763 2.74973 8.36864 2.73474C8.33524 2.66533 8.302 2.59658 8.26355 2.52945C8.24693 2.49947 8.22852 2.47046 8.2106 2.44097C8.1785 2.38835 8.1451 2.33653 8.11039 2.28553C8.0897 2.25588 8.06868 2.22622 8.04701 2.19706C8.0356 2.1824 8.02599 2.16675 8.01361 2.15242C8.70787 1.9186 9.42788 1.76936 10.158 1.70793C9.63774 2.68994 9.4678 3.5983 9.66202 4.41086C9.80687 4.95506 10.0817 5.45608 10.463 5.87075C10.777 6.25952 11.0028 6.53976 10.9888 6.99728C10.9601 7.96496 9.86732 8.77051 9.45379 9.07487C8.91138 9.46542 8.3051 9.75822 7.66199 9.94038C7.05588 10.1383 6.53302 10.3091 6.3331 10.9058C6.13546 11.6937 6.46002 12.5205 7.14109 12.9633C7.54924 13.1838 8.03023 13.2263 8.4708 13.0808C8.95342 12.9687 9.45232 12.9447 9.94341 13.0104C10.5774 13.1002 11.124 13.1772 11.3833 13.5403C11.5371 13.7571 11.5291 13.9813 11.4991 14.3926C11.4307 14.9747 11.4898 15.5649 11.6721 16.122C11.8243 16.5785 12.0542 17.2679 12.6066 17.3474C12.6424 17.3531 12.6788 17.356 12.7149 17.356C13.1058 17.356 13.345 17.0109 13.5966 16.6479C13.7077 16.4874 13.8302 16.3142 13.977 16.1404C14.6638 17.25 15.3615 18.1759 15.3939 18.2199C15.457 18.304 15.5559 18.3534 15.6608 18.3534C15.7659 18.3534 15.8648 18.304 15.9278 18.2199C16.6518 17.2505 17.3116 16.2344 17.9029 15.1787C18.3129 15.2975 18.7033 15.4754 19.0617 15.707C17.3921 18.5851 14.3161 20.356 10.9888 20.3545ZM17.2171 11.2738C17.713 11.716 17.9965 12.3489 17.9963 13.0133C17.9963 13.2533 17.8989 13.7291 17.4361 14.6327C16.9079 15.6118 16.3148 16.5542 15.6605 17.4538C15.3465 17.0163 14.8062 16.2398 14.3228 15.4236C14.0533 14.9762 13.8126 14.5123 13.6019 14.0344C13.445 13.7149 13.3509 13.3684 13.3246 13.0133C13.3261 11.7239 14.371 10.679 15.6605 10.6775C15.7326 10.6775 15.8042 10.6808 15.8754 10.6873C16.3743 10.7324 16.8452 10.9384 17.2171 11.2738ZM20.3204 11.4661C20.2629 12.7354 19.943 13.9789 19.3808 15.1183C19.0151 14.8871 18.6212 14.7036 18.2089 14.5723C18.4667 14.0898 18.6216 13.5588 18.6637 13.0133C18.6609 11.8682 18.0098 10.8235 16.9828 10.3164L16.9618 10.3071C16.8872 10.2711 16.8114 10.2374 16.734 10.2071C16.6809 10.1864 16.6259 10.1703 16.5714 10.153C16.538 10.1429 16.508 10.1304 16.4756 10.1196C16.3896 10.0952 16.3021 10.0753 16.2141 10.0588H16.2097C16.1564 10.0489 16.1023 10.0435 16.0482 10.0365C15.1902 9.91773 14.3229 10.1779 13.672 10.7493C13.0209 11.3209 12.6506 12.1472 12.6572 13.0133C12.6832 13.4581 12.7954 13.8938 12.9877 14.2958C13.1747 14.7217 13.3857 15.1367 13.6197 15.5387C13.4111 15.7669 13.2202 16.0105 13.0483 16.2675C12.9566 16.4247 12.8407 16.5665 12.705 16.6877C12.6382 16.6776 12.5145 16.5352 12.3045 15.9108C12.1513 15.4368 12.1033 14.935 12.164 14.4406C12.2507 13.9966 12.1655 13.5364 11.9258 13.1528C11.4998 12.5569 10.756 12.452 10.0322 12.3494C9.46959 12.2725 8.89769 12.2982 8.34437 12.4251C7.91748 12.5068 7.71935 12.5372 7.49271 12.396C7.07869 12.1121 6.87176 11.6101 6.96545 11.1169C7.05457 10.85 7.32162 10.7536 7.86648 10.5747C8.57801 10.3705 9.24865 10.0447 9.84891 9.61141C10.3351 9.25475 11.6176 8.30826 11.6562 7.017C11.6775 6.31051 11.3241 5.87466 10.9824 5.45331C10.6667 5.11506 10.4369 4.70593 10.3125 4.2603C10.1352 3.51683 10.3548 2.64497 10.9505 1.66785H10.9888C12.8259 1.67045 14.6218 2.21335 16.1527 3.22893C15.9759 3.42591 15.762 3.58592 15.5229 3.69981C15.2903 3.8005 15.0359 3.84026 14.7835 3.81549C14.4326 3.77215 14.0784 3.86323 13.7918 4.07048C13.0351 4.64011 12.696 6.09267 13.3761 7.18352C13.8602 7.95665 14.6871 8.13685 15.5901 8.33368C16.0761 8.43633 16.5784 8.43421 17.0637 8.32732C17.4531 8.23445 17.8591 8.23559 18.2479 8.33107C18.6853 8.45718 19.0959 8.66281 19.4593 8.93735C19.8366 9.25035 20.1228 9.65899 20.2878 10.1206C20.3152 10.4153 20.3321 10.7109 20.3321 11.0112C20.3321 11.1604 20.3292 11.3115 20.3191 11.4661H20.3204Z"
                      fill="#FFB201"
                      stroke="#FFB201"
                      stroke-width="0.3"
                    />
                    <path
                      d="M5.64976 5.00497C6.38688 5.00497 6.98452 4.40749 6.98452 3.67021C6.98452 2.93309 6.38688 2.33545 5.64976 2.33545C4.91265 2.33545 4.315 2.93309 4.315 3.67021C4.315 4.40749 4.91265 5.00497 5.64976 5.00497ZM5.64976 3.00283C6.01832 3.00283 6.31714 3.30165 6.31714 3.67021C6.31714 4.03877 6.01832 4.33759 5.64976 4.33759C5.2812 4.33759 4.98238 4.03877 4.98238 3.67021C4.98238 3.30165 5.2812 3.00283 5.64976 3.00283Z"
                      fill="#FFB201"
                      stroke="#FFB201"
                      stroke-width="0.3"
                    />
                    <path
                      d="M14.3257 12.6795C14.3257 13.4168 14.9234 14.0143 15.6605 14.0143C16.3976 14.0143 16.9952 13.4168 16.9952 12.6795C16.9952 11.9424 16.3976 11.3447 15.6605 11.3447C14.9234 11.3447 14.3257 11.9424 14.3257 12.6795ZM16.3279 12.6795C16.3279 13.0481 16.029 13.3469 15.6605 13.3469C15.2919 13.3469 14.9931 13.0481 14.9931 12.6795C14.9931 12.3109 15.2919 12.0121 15.6605 12.0121C16.029 12.0121 16.3279 12.3109 16.3279 12.6795Z"
                      fill="#FFB201"
                      stroke="#FFB201"
                      stroke-width="0.3"
                    />
                  </svg>
                </div>
              </div>
              <div className={styles.stat}>
                <div className={styles._90_k}>25k+</div>
                <div className={styles.professional_medical_team}>
                  Clinics in 164 Countries
                </div>
              </div>
            </div>
            <div className={styles.statistics2}>
              <div className={styles.icon}>
                <div className={styles.icon7}></div>
                <div className={styles.icon_line_patients}>
                  <div className={styles.ellipse_48}></div>
                  <svg
                    className={styles.group12}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask id="path-1-inside-1_201_220" fill="white">
                      <path
                        d="M18.6323 0H15.1167C14.3628 0 13.7495 0.61332 13.7495 1.36719V6.44531C13.7495 7.28027 14.3349 7.98066 15.1167 8.15883V8.78906C15.1167 9.55293 15.6066 10.2042 16.2886 10.4461V11.1287C16.2886 12.0433 16.6806 12.9163 17.3641 13.5239C17.7977 13.9093 18.0464 14.463 18.0464 15.0431V16.6016C18.0464 16.9246 17.7835 17.1875 17.4604 17.1875H16.0151V16.9349C16.0151 15.096 14.7771 13.4701 13.0043 12.9811L10.3511 12.2491V11.448C11.6388 10.6573 12.4995 9.2359 12.4995 7.61719V3.32031C12.4995 1.92027 11.3605 0.78125 9.96045 0.78125H9.40838C8.81943 0.275742 8.07744 0 7.29311 0H5.27295C3.44213 0 1.95264 1.48949 1.95264 3.32031C1.95264 4.30176 2.61447 5.13109 3.51514 5.38684V7.61719C3.51514 9.2359 4.37588 10.6573 5.66357 11.448V12.2491L3.01037 12.9811C1.2376 13.4701 -0.000488281 15.096 -0.000488281 16.9349V19.4141C-0.000488281 19.7377 0.261855 20 0.585449 20H15.4292C15.7528 20 16.0151 19.7377 16.0151 19.4141V18.3594H17.4604C18.4297 18.3594 19.2183 17.5708 19.2183 16.6016V15.0431C19.2183 14.1286 18.8262 13.2556 18.1427 12.648C17.7091 12.2626 17.4604 11.7089 17.4604 11.1287V10.4461C18.1424 10.2042 18.6323 9.55293 18.6323 8.78906V8.15883C19.4141 7.98066 19.9995 7.28027 19.9995 6.44531V1.36719C19.9995 0.61332 19.3862 0 18.6323 0V0ZM4.10107 4.29688C4.10104 4.29688 4.10104 4.29688 4.101 4.29688C3.56256 4.29684 3.12451 3.85875 3.12451 3.32031C3.12451 2.13566 4.0883 1.17188 5.27295 1.17188H7.29311C7.84908 1.17188 8.37174 1.38836 8.7649 1.78148C8.87479 1.89137 9.02381 1.95312 9.1792 1.95312H9.96045C10.7143 1.95312 11.3276 2.56645 11.3276 3.32031V4.28395C10.5249 4.21684 9.779 3.87273 9.20287 3.2966C9.01279 3.10648 8.71771 3.0702 8.48709 3.20848C7.30041 3.92051 5.94166 4.29688 4.55771 4.29688H4.10107ZM4.68701 7.61719V5.46781C6.0924 5.44715 7.47189 5.0902 8.70908 4.42926C9.45314 5.0416 10.3618 5.39992 11.3276 5.4598V7.61719C11.3276 9.44801 9.83814 10.9375 8.00732 10.9375C6.1765 10.9375 4.68701 9.44801 4.68701 7.61719ZM9.1792 11.954V13.2812C9.1792 13.9274 8.6535 14.4531 8.00732 14.4531C7.36115 14.4531 6.83545 13.9274 6.83545 13.2812V11.954C7.2092 12.0551 7.60201 12.1094 8.00732 12.1094C8.41264 12.1094 8.80545 12.0551 9.1792 11.954ZM14.8433 18.8281H13.2808V17.3828C13.2808 17.0592 13.0184 16.7969 12.6948 16.7969C12.3712 16.7969 12.1089 17.0592 12.1089 17.3828V18.8281H3.90576V17.3828C3.90576 17.0592 3.64342 16.7969 3.31982 16.7969C2.99623 16.7969 2.73389 17.0592 2.73389 17.3828V18.8281H1.17139V16.9349C1.17139 15.6214 2.05576 14.46 3.32197 14.1107L5.67127 13.4627C5.76428 14.6705 6.77607 15.625 8.00732 15.625C9.23857 15.625 10.2504 14.6705 10.3434 13.4627L12.6927 14.1107C13.9589 14.46 14.8433 15.6214 14.8433 16.9349V18.8281ZM17.4604 8.78906C17.4604 9.11215 17.1976 9.375 16.8745 9.375C16.5514 9.375 16.2886 9.11215 16.2886 8.78906V8.20312H17.4604V8.78906ZM18.8276 6.44531C18.8276 6.7684 18.5648 7.03125 18.2417 7.03125H15.5073C15.1842 7.03125 14.9214 6.7684 14.9214 6.44531V3.90625H18.8276V6.44531ZM18.8276 2.73438H14.9214V1.36719C14.9214 1.25949 15.009 1.17188 15.1167 1.17188H18.6323C18.74 1.17188 18.8276 1.25949 18.8276 1.36719V2.73438Z"
                      />
                    </mask>
                    <path
                      d="M18.6323 0H15.1167C14.3628 0 13.7495 0.61332 13.7495 1.36719V6.44531C13.7495 7.28027 14.3349 7.98066 15.1167 8.15883V8.78906C15.1167 9.55293 15.6066 10.2042 16.2886 10.4461V11.1287C16.2886 12.0433 16.6806 12.9163 17.3641 13.5239C17.7977 13.9093 18.0464 14.463 18.0464 15.0431V16.6016C18.0464 16.9246 17.7835 17.1875 17.4604 17.1875H16.0151V16.9349C16.0151 15.096 14.7771 13.4701 13.0043 12.9811L10.3511 12.2491V11.448C11.6388 10.6573 12.4995 9.2359 12.4995 7.61719V3.32031C12.4995 1.92027 11.3605 0.78125 9.96045 0.78125H9.40838C8.81943 0.275742 8.07744 0 7.29311 0H5.27295C3.44213 0 1.95264 1.48949 1.95264 3.32031C1.95264 4.30176 2.61447 5.13109 3.51514 5.38684V7.61719C3.51514 9.2359 4.37588 10.6573 5.66357 11.448V12.2491L3.01037 12.9811C1.2376 13.4701 -0.000488281 15.096 -0.000488281 16.9349V19.4141C-0.000488281 19.7377 0.261855 20 0.585449 20H15.4292C15.7528 20 16.0151 19.7377 16.0151 19.4141V18.3594H17.4604C18.4297 18.3594 19.2183 17.5708 19.2183 16.6016V15.0431C19.2183 14.1286 18.8262 13.2556 18.1427 12.648C17.7091 12.2626 17.4604 11.7089 17.4604 11.1287V10.4461C18.1424 10.2042 18.6323 9.55293 18.6323 8.78906V8.15883C19.4141 7.98066 19.9995 7.28027 19.9995 6.44531V1.36719C19.9995 0.61332 19.3862 0 18.6323 0V0ZM4.10107 4.29688C4.10104 4.29688 4.10104 4.29688 4.101 4.29688C3.56256 4.29684 3.12451 3.85875 3.12451 3.32031C3.12451 2.13566 4.0883 1.17188 5.27295 1.17188H7.29311C7.84908 1.17188 8.37174 1.38836 8.7649 1.78148C8.87479 1.89137 9.02381 1.95312 9.1792 1.95312H9.96045C10.7143 1.95312 11.3276 2.56645 11.3276 3.32031V4.28395C10.5249 4.21684 9.779 3.87273 9.20287 3.2966C9.01279 3.10648 8.71771 3.0702 8.48709 3.20848C7.30041 3.92051 5.94166 4.29688 4.55771 4.29688H4.10107ZM4.68701 7.61719V5.46781C6.0924 5.44715 7.47189 5.0902 8.70908 4.42926C9.45314 5.0416 10.3618 5.39992 11.3276 5.4598V7.61719C11.3276 9.44801 9.83814 10.9375 8.00732 10.9375C6.1765 10.9375 4.68701 9.44801 4.68701 7.61719ZM9.1792 11.954V13.2812C9.1792 13.9274 8.6535 14.4531 8.00732 14.4531C7.36115 14.4531 6.83545 13.9274 6.83545 13.2812V11.954C7.2092 12.0551 7.60201 12.1094 8.00732 12.1094C8.41264 12.1094 8.80545 12.0551 9.1792 11.954ZM14.8433 18.8281H13.2808V17.3828C13.2808 17.0592 13.0184 16.7969 12.6948 16.7969C12.3712 16.7969 12.1089 17.0592 12.1089 17.3828V18.8281H3.90576V17.3828C3.90576 17.0592 3.64342 16.7969 3.31982 16.7969C2.99623 16.7969 2.73389 17.0592 2.73389 17.3828V18.8281H1.17139V16.9349C1.17139 15.6214 2.05576 14.46 3.32197 14.1107L5.67127 13.4627C5.76428 14.6705 6.77607 15.625 8.00732 15.625C9.23857 15.625 10.2504 14.6705 10.3434 13.4627L12.6927 14.1107C13.9589 14.46 14.8433 15.6214 14.8433 16.9349V18.8281ZM17.4604 8.78906C17.4604 9.11215 17.1976 9.375 16.8745 9.375C16.5514 9.375 16.2886 9.11215 16.2886 8.78906V8.20312H17.4604V8.78906ZM18.8276 6.44531C18.8276 6.7684 18.5648 7.03125 18.2417 7.03125H15.5073C15.1842 7.03125 14.9214 6.7684 14.9214 6.44531V3.90625H18.8276V6.44531ZM18.8276 2.73438H14.9214V1.36719C14.9214 1.25949 15.009 1.17188 15.1167 1.17188H18.6323C18.74 1.17188 18.8276 1.25949 18.8276 1.36719V2.73438Z"
                      fill="#4EB2F9"
                      stroke="#4EB2F9"
                      stroke-width="2"
                      mask="url(#path-1-inside-1_201_220)"
                    />
                  </svg>
                </div>
              </div>
              <div className={styles.stat}>
                <div className={styles._90_k}>300k+</div>
                <div className={styles.professional_medical_team}>
                  Patients served every day
                </div>
              </div>
            </div>
          </div>
          <div className={styles.frame_112}>
            <div
              className={styles.pradhan_capital_is_proud_to_offer_comprehensive_advisory_services_to_med_tech_startups}
            >
              Pradhan Capital is proud to offer comprehensive advisory services
              to MedTech startups. 
            </div>
            <div
              className={styles.our_team_is_equipped_to_provide_valuable_expertise_and_guidance_in_various_capacities_including_serving_as_scientific_advisors_board_members_and_offering_business_advisory_support}
            >
              Our team is equipped to provide valuable expertise and guidance in
              various capacities, including serving as scientific advisors,
              board members, and offering business advisory support.
            </div>
            <div
              className={styles.with_a_deep_understanding_of_the_healthcare_industry_and_a_network_of_experienced_professionals_we_are_committed_to_helping_startups_navigate_challenges_make_informed_decisions_and_maximize_their_growth_potential_whether_you_need_scientific_insights_strategic_direction_or_operational_guidance_pradhan_capital_is_dedicated_to_partnering_with_you_every_step_of_the_way}
            >
              With a deep understanding of the healthcare industry and a network
              of experienced professionals, we are committed to helping startups
              navigate challenges, make informed decisions, and maximize their
              growth potential.<br />Whether you need scientific insights,
              strategic direction, or operational guidance, Pradhan Capital is
              dedicated to partnering with you every step of the way.
            </div>
          </div>
        </div>
      </div>
      <div className={styles.frame_9}>
        <div className={styles.frame_8}>
          <div className={styles.frame_7}>
            <div className={styles.frame_12}>
              <div className={styles.mask_group2}>
                <div className={styles.ellipse_4432}></div>
                <div className={styles.group_397862}>
                  <div className={styles.ellipse_4442}></div>
                  <div className={styles.ellipse_4452}></div>
                  <div className={styles.ellipse_4462}></div>
                  <div className={styles.ellipse_4472}></div>
                </div>
              </div>
              <div className={styles.pradhan_capital2}>Pradhan Capital</div>
            </div>
            <div
              className={styles.empowering_healthcare_innovation_through_frontline_experience}
            >
              Empowering Healthcare Innovation through Frontline Experience
            </div>
          </div>
          <div className={styles.button}>
            <div className={styles.button_normal}>Apply Now</div>
          </div>
        </div>
        <div className={styles.mask_group3}>
          <div className={styles.ellipse_4433}></div>
          <div className={styles.group_397863}>
            <div className={styles.ellipse_4443}></div>
            <div className={styles.ellipse_4453}></div>
            <div className={styles.ellipse_4463}></div>
            <div className={styles.ellipse_4473}></div>
          </div>
        </div>
        <div className={styles.mask_group3}>
          <div className={styles.ellipse_4434}></div>
          <div className={styles.group_397863}>
            <div className={styles.ellipse_4444}></div>
            <div className={styles.ellipse_4454}></div>
            <div className={styles.ellipse_4464}></div>
            <div className={styles.ellipse_4474}></div>
          </div>
        </div>
      </div>
      <div className={styles.frame_122}>
        <div className={styles.frame_82}>
          <div className={styles.frame_7}>
            <div className={styles.frame_123}>
              <div className={styles.mask_group2}>
                <div className={styles.ellipse_4432}></div>
                <div className={styles.group_397862}>
                  <div className={styles.ellipse_4442}></div>
                  <div className={styles.ellipse_4452}></div>
                  <div className={styles.ellipse_4462}></div>
                  <div className={styles.ellipse_4472}></div>
                </div>
              </div>
              <div className={styles.pradhan_capital2}>Pradhan Capital</div>
            </div>
            <div className={styles.frame_39788}>
              <div className={styles.apply_to_join_our_portfolio}>
                Apply to Join Our Portfolio
              </div>
              <div
                className={styles.if_your_startup_shares_our_vision_of_improving_healthcare_through_innovation_we_invite_you_to_connect_with_us_together_let_s_explore_how_pradhan_capital_can_contribute_to_the_growth_and_success_of_your_med_tech_venture}
              >
                If your startup shares our vision of improving healthcare
                through innovation, we invite you to connect with us. Together,
                let&#039;s explore how Pradhan Capital can contribute to the
                growth and success of your MedTech venture.
              </div>
            </div>
          </div>
          <div className={styles.button}>
            <div className={styles.button_normal}>Apply Now</div>
          </div>
        </div>
        <div className={styles.mask_group3}>
          <div className={styles.ellipse_4433}></div>
          <div className={styles.group_397863}>
            <div className={styles.ellipse_4443}></div>
            <div className={styles.ellipse_4453}></div>
            <div className={styles.ellipse_4463}></div>
            <div className={styles.ellipse_4473}></div>
          </div>
        </div>
        <div className={styles.mask_group3}>
          <div className={styles.ellipse_4434}></div>
          <div className={styles.group_397863}>
            <div className={styles.ellipse_4444}></div>
            <div className={styles.ellipse_4454}></div>
            <div className={styles.ellipse_4464}></div>
            <div className={styles.ellipse_4474}></div>
          </div>
        </div>
      </div>
      <div className={styles.core_value}>
        <div className={styles.core_values}>
          <div className={styles.frame_132}>
            <div className={styles.title4}>
              <div className={styles.bg4}></div>
              <div className={styles.title5}>
                <div className={styles.our_core_values_that_drive_us_everyday}>
                  Our core values that drive us everyday
                </div>
                <div
                  className={styles.we_believe_that_improving_healthcare_doesn_t_just_change_lives_it_changes_the_world_creating_an_equitable_health_system_starts_with_bringing_diverse_experiences_backgrounds_and_perspectives_together}
                >
                  We believe that improving healthcare doesn’t just change
                  lives—it changes the world. Creating an equitable health
                  system starts with bringing diverse experiences, backgrounds,
                  and perspectives together
                </div>
              </div>
              <div className={styles.mask_group4}>
                <div className={styles.ellipse_4435}></div>
                <div className={styles.group_397863}>
                  <div className={styles.ellipse_4445}></div>
                  <div className={styles.ellipse_4455}></div>
                  <div className={styles.ellipse_4465}></div>
                  <div className={styles.ellipse_4475}></div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.points}>
            <div className={styles.column_1}>
              <div className={styles.core_values2}>
                <div className={styles.icon}>
                  <div className={styles.ellipse_46}></div>
                  <div className={styles.icon_line_safe}>
                    <svg
                      className={styles.group_25}
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.9118 25.1112H1.22293C1.05182 25.1112 0.890704 25.0323 0.785149 24.8979C0.679593 24.7623 0.641816 24.5879 0.682927 24.4212L1.28293 22.0101C1.58515 20.8112 2.46182 19.8667 3.62626 19.4834L8.0907 17.9956C8.75293 17.719 9.16626 16.7212 9.20848 15.2501C8.69737 14.7856 7.6007 13.6523 7.6007 12.4901C7.6007 12.0823 7.46404 11.999 7.46293 11.9979C7.29404 11.9523 7.20515 11.8479 7.13959 11.6845C7.08404 11.5445 6.6007 10.3045 6.6007 9.46675C6.6007 9.4223 6.60626 9.37786 6.61737 9.33452C6.68737 9.04675 6.85626 8.75786 7.1107 8.5823C7.11737 8.44897 7.12515 8.30119 7.13404 8.13675C7.16181 7.58786 7.2007 6.85564 7.2007 5.94452C7.2007 3.86008 9.74959 0.666748 12.8896 0.666748C15.7307 0.666748 17.1063 2.18008 17.334 3.15786C18.0285 3.5423 18.634 4.17675 18.634 5.94452V8.58563C18.9096 8.77563 19.0796 9.08008 19.1507 9.29008C19.1696 9.34675 19.1785 9.40675 19.1785 9.46675C19.1785 9.77341 18.9296 10.0445 18.6229 10.0445C18.344 10.0445 18.114 9.85786 18.074 9.59452C18.0529 9.55563 18.0263 9.51675 18.0085 9.50341C17.7029 9.50341 17.5218 9.27341 17.5218 8.96675V5.94452C17.5218 4.49452 17.0563 4.26008 16.7785 4.12119C16.6107 4.03564 16.2563 3.85786 16.2563 3.43341C16.2363 3.09897 15.3007 1.77786 12.8896 1.77786C10.2451 1.77786 8.31181 4.51786 8.31181 5.94452C8.31181 6.88008 8.27293 7.63119 8.24181 8.19452C8.22626 8.51564 8.21181 8.77452 8.21181 8.96675C8.21181 9.25452 7.99293 9.49119 7.71293 9.52008C7.7307 9.97563 7.95848 10.6901 8.10404 11.089C8.40181 11.3001 8.71181 11.7312 8.71181 12.489C8.71181 13.1156 9.44293 14.0079 10.1229 14.5723C10.2496 14.6779 10.3229 14.8345 10.3229 15.0001C10.3229 17.109 9.66848 18.5423 8.47959 19.0356L3.97626 20.539C3.17182 20.8045 2.56848 21.4556 2.3607 22.2812L1.93404 24.0001H12.9118C13.2185 24.0001 13.4674 24.249 13.4674 24.5556C13.4674 24.8623 13.2185 25.1112 12.9118 25.1112Z"
                        fill="#FFB201"
                        stroke="#FFB201"
                        stroke-width="0.3"
                      />
                      <path
                        d="M14 14.0001L20 12.6667L26 14.0001V22.6667L20.6667 26.6667L15.3333 22.6667L14 14.0001Z"
                        fill="white"
                      />
                      <path
                        d="M20.6675 27.3334C20.5941 27.3334 20.5208 27.319 20.4519 27.289C20.1875 27.179 14.0008 24.5045 14.0008 19.0401V14.3968C14.0008 14.159 14.153 13.9468 14.3786 13.8701L20.4897 11.8068C20.6052 11.7679 20.7308 11.7679 20.8452 11.8068L26.9563 13.8701C27.1819 13.9456 27.3341 14.1579 27.3341 14.3968V19.0401C27.3341 24.5045 21.1475 27.179 20.883 27.2901C20.8141 27.319 20.7408 27.3334 20.6675 27.3334ZM15.1119 14.7956V19.0401C15.1119 23.2456 19.6175 25.6601 20.6675 26.1668C21.7163 25.659 26.223 23.2356 26.223 19.0401V14.7956L20.6675 12.9201L15.1119 14.7956Z"
                        fill="#FFB201"
                        stroke="#FFB201"
                        stroke-width="0.3"
                      />
                      <path
                        d="M20.6667 16.6667V22.0001"
                        stroke="#FFB201"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M18 19.3335H23.3333"
                        stroke="#FFB201"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div className={styles.keep_healtcare_human}>Keep healtcare human</div>
              </div>
              <div className={styles.core_values2}>
                <div className={styles.icon}>
                  <div className={styles.ellipse_47}></div>
                  <div className={styles.icon_line_healthcare}>
                    <div className={styles.group15}>
                      <svg
                        className={styles.vector21}
                        width="28"
                        height="13"
                        viewBox="0 0 28 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M26.8404 2.31124C26.0508 1.27692 24.6015 1.05759 23.5412 1.81233L19.0192 5.13967C19.0458 4.99201 19.0605 4.84024 19.0605 4.68503C19.0605 3.27384 17.9123 2.12572 16.5011 2.12572H12.3153C11.7928 1.52978 10.5318 0.392334 8.51723 0.392334C6.38301 0.392334 5.12207 1.61348 4.67499 2.14395L0.666656 3.41228V5.05217L5.63968 3.47863L5.79218 3.24988C5.80082 3.23696 6.67619 1.95587 8.51723 1.95587C10.3037 1.95587 11.2261 3.25144 11.2863 3.33894L11.5096 3.68926H16.5011C17.0502 3.68926 17.497 4.13597 17.497 4.68509C17.497 5.23316 17.0519 5.67915 16.5041 5.68081H12.3032V7.2443H18.7971L24.4521 3.08321C24.8212 2.82368 25.3234 2.90103 25.5976 3.26014C25.8659 3.61149 25.8145 4.10936 25.482 4.39868L18.2196 10.1479C17.6071 10.6299 16.8428 10.8501 16.068 10.7686L5.6615 9.67148L0.666656 11.1517V12.7824L5.80723 11.259L15.9041 12.3235C17.0865 12.4483 18.2521 12.1119 19.1883 11.3753L26.4643 5.61508L26.4845 5.59852C27.4601 4.77165 27.6164 3.32769 26.8404 2.31124Z"
                          fill="#1EBCB4"
                        />
                      </svg>

                      <div className={styles.ellipse_49}></div>
                      <svg
                        className={styles.vector22}
                        width="12"
                        height="11"
                        viewBox="0 0 12 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.21117 10.8512C9.20289 10.8512 11.6368 8.41729 11.6368 5.42562C11.6368 2.43396 9.20289 0 6.21117 0C3.21946 0 0.785553 2.43391 0.785553 5.42562C0.785553 8.41734 3.21946 10.8512 6.21117 10.8512ZM6.21117 1.56349C8.34076 1.56349 10.0733 3.29604 10.0733 5.42562C10.0733 7.55521 8.34076 9.28776 6.21117 9.28776C4.08159 9.28776 2.34904 7.55521 2.34904 5.42562C2.34904 3.29604 4.08159 1.56349 6.21117 1.56349Z"
                          fill="#1EBCB4"
                        />
                      </svg>

                      <svg
                        className={styles.group_262}
                        width="7"
                        height="7"
                        viewBox="0 0 7 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.33331 0.666748V6.00008"
                          stroke="#1EBCB4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M0.666656 3.3335L5.99999 3.3335"
                          stroke="#1EBCB4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className={styles.keep_healtcare_human}>
                  Be humble, caring and daring
                </div>
              </div>
              <div className={styles.core_values2}>
                <div className={styles.icon}>
                  <div className={styles.ellipse_410}></div>
                  <div className={styles.icon_line_discipline}>
                    <svg
                      className={styles.ellipse_50}
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.6667 6C12.6667 9.31371 9.98036 12 6.66666 12C3.33332 11.3333 1.99999 7.33333 0.666656 6C0.666656 2.68629 3.35295 0 6.66666 0C9.98036 0 12.6667 2.68629 12.6667 6Z"
                        fill="white"
                      />
                    </svg>

                    <svg
                      className={styles.group16}
                      width="24"
                      height="28"
                      viewBox="0 0 24 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.6383 9.74021C17.7909 9.89286 17.991 9.96921 18.191 9.96921C18.391 9.96921 18.5911 9.89286 18.7437 9.74027C19.049 9.43498 19.049 8.94005 18.7437 8.63477L17.4874 7.37845V5.40916C17.4874 4.97744 17.1374 4.62744 16.7057 4.62744C16.274 4.62744 15.924 4.97744 15.924 5.40916V7.70218C15.924 7.90949 16.0064 8.10831 16.153 8.25491L17.6383 9.74021Z"
                        fill="#A27FFF"
                      />
                      <path
                        d="M13.7767 14.0966C14.6922 14.5174 15.692 14.7376 16.7058 14.7376C20.5851 14.7376 23.7412 11.5815 23.7412 7.70218C23.7412 3.82284 20.5851 0.666748 16.7058 0.666748C13.0291 0.666748 10.0027 3.50176 9.69633 7.10041C9.37896 7.04147 9.05189 7.01036 8.71773 7.01036C5.76838 7.01036 3.36888 9.40986 3.36888 12.3592C3.36888 14.188 4.29157 15.805 5.69563 16.77H3.95611C1.77476 16.77 6.10352e-05 18.5512 6.10352e-05 20.7406V26.5517C6.10352e-05 26.9834 0.35006 27.3334 0.781775 27.3334C1.21349 27.3334 1.56349 26.9834 1.56349 26.5517V20.7406C1.56349 19.4133 2.63683 18.3335 3.95611 18.3335H7.75596L5.97632 22.8824C5.87631 23.1381 5.91769 23.4274 6.08544 23.6448L8.09883 26.2538C8.24683 26.4455 8.4754 26.5579 8.71768 26.5579C8.95996 26.5579 9.18853 26.4455 9.33654 26.2538L11.3499 23.6448C11.5176 23.4274 11.5591 23.1381 11.459 22.8824L9.67945 18.3335H13.4793C14.7986 18.3335 15.8719 19.4133 15.8719 20.7406V26.5514C15.8719 26.9831 16.2219 27.3331 16.6536 27.3331C17.0854 27.3331 17.4354 26.9831 17.4354 26.5514V20.7406C17.4354 18.5512 15.6607 16.7701 13.4793 16.7701H11.7398C12.6772 16.1258 13.3998 15.1911 13.7767 14.0966ZM8.71773 24.4966L7.59352 23.0399L8.71773 20.1664L9.84194 23.0399L8.71773 24.4966ZM15.9269 2.28583C15.9554 2.69154 16.2928 3.01205 16.7058 3.01205C17.1187 3.01205 17.4561 2.69154 17.4847 2.28583C19.8798 2.62869 21.7792 4.5281 22.122 6.92322C21.7163 6.95183 21.3959 7.28917 21.3959 7.70212C21.3959 8.11508 21.7164 8.45241 22.122 8.48102C21.7792 10.8761 19.8798 12.7756 17.4847 13.1184C17.456 12.7127 17.1187 12.3923 16.7058 12.3923C16.2931 12.3923 15.9559 12.7123 15.9269 13.1175C15.2747 13.0234 14.6432 12.8117 14.065 12.4912C14.0661 12.4473 14.0666 12.4033 14.0666 12.3592C14.0666 10.6097 13.2223 9.05371 11.9198 8.07719C11.9808 7.96582 12.0157 7.83804 12.0157 7.70207C12.0157 7.28912 11.6952 6.95178 11.2895 6.92317C11.6323 4.52816 13.5317 2.62869 15.9269 2.28583ZM4.93226 12.3593C4.93226 10.272 6.6304 8.57384 8.71768 8.57384C10.805 8.57384 12.5032 10.272 12.5032 12.3593C12.5032 14.4465 10.805 16.1447 8.71773 16.1447C6.6304 16.1447 4.93226 14.4465 4.93226 12.3593Z"
                        fill="#A27FFF"
                      />
                    </svg>
                  </div>
                </div>
                <div className={styles.keep_healtcare_human}>
                  Disciplined and dedicated
                </div>
              </div>
            </div>
            <div className={styles.column_2}>
              <div className={styles.core_values2}>
                <div className={styles.icon}>
                  <div className={styles.ellipse_411}></div>
                  <svg
                    className={styles.icon_line_procedures}
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="17.3333"
                      y="5.33325"
                      width="6.66667"
                      height="5.33333"
                      fill="white"
                    />
                    <rect
                      x="8"
                      y="13.3333"
                      width="6.66667"
                      height="5.33333"
                      fill="white"
                    />
                    <rect
                      x="17.3333"
                      y="20"
                      width="6.66667"
                      height="6.66667"
                      fill="white"
                    />
                    <path
                      d="M16.8334 23.25H17.3334V22.75V20.625C17.3334 20.3489 17.5572 20.125 17.8334 20.125H23.6459C23.922 20.125 24.1459 20.3489 24.1459 20.625V22.75V23.25H24.6459H28.5521C28.7074 23.25 28.8334 23.3759 28.8334 23.5312C28.8334 23.6866 28.7074 23.8125 28.5521 23.8125H24.6459H24.1459V24.3125V26.4375C24.1459 26.7136 23.922 26.9375 23.6459 26.9375H17.8334C17.5572 26.9375 17.3334 26.7136 17.3334 26.4375V24.3125V23.8125H16.8334H7.35419C5.04564 23.8125 3.16669 21.9335 3.16669 19.625C3.16669 17.3165 5.04564 15.4375 7.35419 15.4375H7.85419V14.9375V12.8125C7.85419 12.5364 8.07804 12.3125 8.35419 12.3125H14.1667C14.4428 12.3125 14.6667 12.5364 14.6667 12.8125V14.9375V15.4375H15.1667H24.6459C26.6451 15.4375 28.2709 13.8118 28.2709 11.8125C28.2709 9.81323 26.6451 8.1875 24.6459 8.1875H24.1459V8.6875V10.8125C24.1459 11.0886 23.922 11.3125 23.6459 11.3125H17.8334C17.5572 11.3125 17.3334 11.0886 17.3334 10.8125V8.6875V8.1875H16.8334H3.44794C3.29261 8.1875 3.16669 8.06158 3.16669 7.90625C3.16669 7.75092 3.29261 7.625 3.44794 7.625H16.8334H17.3334V7.125V5C17.3334 4.72386 17.5572 4.5 17.8334 4.5H23.6459C23.922 4.5 24.1459 4.72386 24.1459 5V7.125V7.625H24.6459C26.9544 7.625 28.8334 9.50396 28.8334 11.8125C28.8334 14.121 26.9544 16 24.6459 16H15.1667H14.6667V16.5V18.625C14.6667 18.9011 14.4428 19.125 14.1667 19.125H8.35419C8.07804 19.125 7.85419 18.9011 7.85419 18.625V16.5V16H7.35419C5.35492 16 3.72919 17.6257 3.72919 19.625C3.72919 21.6243 5.35492 23.25 7.35419 23.25H16.8334ZM23.0834 10.75H23.5834V10.25V5.5625V5.0625H23.0834H21.5209H21.0209V5.5625V6.625H20.4584V5.5625V5.0625H19.9584H18.3959H17.8959V5.5625V10.25V10.75H18.3959H23.0834ZM8.91669 12.875H8.41669V13.375V18.0625V18.5625H8.91669H13.6042H14.1042V18.0625V13.375V12.875H13.6042H12.0417H11.5417V13.375V14.4375H10.9792V13.375V12.875H10.4792H8.91669ZM23.0834 26.375H23.5834V25.875V21.1875V20.6875H23.0834H21.5209H21.0209V21.1875V22.25H20.4584V21.1875V20.6875H19.9584H18.3959H17.8959V21.1875V25.875V26.375H18.3959H23.0834Z"
                      fill="#4EB2F9"
                      stroke="#4EB2F9"
                    />
                  </svg>
                </div>
                <div className={styles.keep_healtcare_human}>Stick to the procedure</div>
              </div>
              <div className={styles.core_values2}>
                <div className={styles.icon}>
                  <div className={styles.ellipse_412}></div>
                  <div className={styles.icon_line_stay_for_everyone}>
                    <svg
                      className={styles.group17}
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.66669 4.66683L12 1.3335H15.3334L19.3334 4.66683C19.3334 8.00016 18.2667 14.6668 14 14.6668C9.73335 14.6668 8.66669 8.00016 8.66669 4.66683Z"
                        fill="white"
                      />
                      <path
                        d="M13.9193 15.2591L13.9192 15.259C12.3433 14.7863 10.9931 13.84 10.011 12.52C9.02884 11.2 8.51044 9.63479 8.51044 7.98951V3.53133C8.51044 3.37602 8.63637 3.25008 8.79169 3.25008C9.9683 3.25008 11.029 2.59455 11.5552 1.54213C11.5552 1.54212 11.5552 1.54211 11.5552 1.5421L11.6651 1.32223C11.7127 1.22694 11.8101 1.16675 11.9167 1.16675H16.0834C16.1899 1.16675 16.2873 1.22692 16.3349 1.32224L16.4449 1.54219L16.4449 1.54223C16.971 2.59455 18.0317 3.25008 19.2084 3.25008C19.3637 3.25008 19.4896 3.37602 19.4896 3.53133V7.98951C19.4896 9.63479 18.9712 11.2 17.9891 12.52C17.007 13.84 15.6567 14.7863 14.0808 15.259L14.0808 15.2591C14.0544 15.267 14.0272 15.2709 14 15.2709C13.9728 15.2709 13.9457 15.267 13.9193 15.2591ZM9.4802 3.7485L9.07294 3.82537V4.23982V7.98956C9.07294 11.03 10.9791 13.675 13.8397 14.6434L14 14.6976L14.1603 14.6434C17.0209 13.675 18.9271 11.03 18.9271 7.98956V4.23982V3.82537L18.5198 3.7485C17.4809 3.55239 16.5778 2.91609 16.0419 1.9807L15.8979 1.72925H15.6081H12.3919H12.1021L11.9581 1.98071C11.4222 2.91614 10.5191 3.55239 9.4802 3.7485Z"
                        fill="#1E5DBC"
                        stroke="#1E5DBC"
                      />
                      <path
                        d="M14.0001 4.66675V10.0001"
                        stroke="#1E5DBC"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.3334 7.3335L16.6667 7.3335"
                        stroke="#1E5DBC"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M24.2689 19.0371C24.875 18.425 25.25 17.5838 25.25 16.6564C25.25 14.7897 23.7313 13.271 21.8646 13.271C19.9979 13.271 18.4792 14.7897 18.4792 16.6564C18.4792 17.5822 18.853 18.422 19.4573 19.0339C18.2089 19.6443 17.2277 20.7165 16.738 22.0356C16.5583 21.8937 16.3674 21.7653 16.1667 21.6521C16.601 21.1498 16.8646 20.496 16.8646 19.7814C16.8646 18.2019 15.5796 16.9168 14 16.9168C12.4205 16.9168 11.1354 18.2019 11.1354 19.7814C11.1354 20.496 11.3991 21.1498 11.8334 21.6521C11.6327 21.7652 11.4418 21.8937 11.262 22.0356C10.7724 20.7165 9.79106 19.6443 8.54278 19.0339C9.147 18.422 9.52085 17.5822 9.52085 16.6564C9.52085 14.7897 8.00216 13.271 6.13544 13.271C4.26872 13.271 2.75002 14.7897 2.75002 16.6564C2.75002 17.5838 3.12507 18.425 3.73117 19.0371C1.91783 19.9284 0.666687 21.7948 0.666687 23.9481V26.5522C0.666687 26.9837 1.01648 27.3335 1.44794 27.3335H26.5521C26.9836 27.3335 27.3334 26.9837 27.3334 26.5522V23.9481C27.3334 21.7948 26.0822 19.9284 24.2689 19.0371ZM20.0417 16.6564C20.0417 15.6513 20.8594 14.8335 21.8646 14.8335C22.8698 14.8335 23.6875 15.6513 23.6875 16.6564C23.6875 17.6616 22.8698 18.4793 21.8646 18.4793C20.8594 18.4793 20.0417 17.6616 20.0417 16.6564ZM12.6979 19.7814C12.6979 19.0634 13.2821 18.4793 14 18.4793C14.718 18.4793 15.3021 19.0634 15.3021 19.7814C15.3021 20.4994 14.718 21.0835 14 21.0835C13.2821 21.0835 12.6979 20.4994 12.6979 19.7814ZM4.31252 16.6564C4.31252 15.6513 5.13028 14.8335 6.13544 14.8335C7.14059 14.8335 7.95835 15.6513 7.95835 16.6564C7.95835 17.6616 7.14059 18.4793 6.13544 18.4793C5.13028 18.4793 4.31252 17.6616 4.31252 16.6564ZM2.22919 23.9481C2.22919 21.7942 3.98153 20.0418 6.13544 20.0418C8.16137 20.0418 9.832 21.575 10.0231 23.5677C9.73523 24.1546 9.57294 24.8139 9.57294 25.5106V25.771H2.22919V23.9481ZM16.8646 25.771H11.1354V25.5106C11.1354 23.931 12.4205 22.646 14 22.646C15.5796 22.646 16.8646 23.931 16.8646 25.5106V25.771ZM25.7709 25.771H18.4271V25.5106C18.4271 24.8139 18.2648 24.1546 17.9769 23.5677C18.168 21.575 19.8387 20.0418 21.8646 20.0418C24.0185 20.0418 25.7709 21.7942 25.7709 23.9481V25.771Z"
                        fill="#1E5DBC"
                      />
                    </svg>
                  </div>
                </div>
                <div className={styles.keep_healtcare_human}>Stay safe for everyone</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
    );
};

export default Anup;